{
  "common": {
    "appTitle": "Draughts MVP",
    "back": "Indietro",
    "exit": "Esci",
    "cancel": "Annulla",
    "close": "Chiudi",
    "continue": "Continua",
    "copy": "Copia",
    "error": "Errore",
    "loading": "Caricamento...",
    "retry": "Riprova",
    "or": "o",
    "vs": "vs",
    "you": "Tu",
    "anonymous": "Anonimo",
    "send": "Invia",
    "download": "Scarica",
    "noLimit": "Nessun limite",
    "comingSoon": "In arrivo",
    "version": "v{{version}}",
    "enabled": "Abilitato",
    "disabled": "Disabilitato",
    "apply": "Applica",
    "errorBoundary": "Qualcosa è andato storto. Prova a ricaricare: se è appena uscita una versione nuova, il ricarico la prende.",
    "dismissNotice": "Chiudi"
  },
  "errors": {
    "loadFailed": "Non è stato possibile caricare questi dati. Riprova.",
    "network": "Nessuna connessione a internet. Controlla la rete e riprova.",
    "notFound": "Questa pagina non esiste (o non esiste più)."
  },
  "senzaRete": {
    "titolo": "Sei senza connessione",
    "dati": "Questa pagina non può caricare i suoi dati finché la connessione non torna.",
    "home": "Partite online, tornei e classifica non sono disponibili. Puoi comunque giocare contro il computer o in presenza su questo dispositivo."
  },
  "avvisoServizio": {
    "etichetta": "Avviso di servizio",
    "preset": {
      "riavvio": "Riavvio programmato: il server sarà irraggiungibile per qualche istante. Le partite in corso non si perdono.",
      "riavvioAlle": "Riavvio programmato alle {{ora}}: il server sarà irraggiungibile per qualche istante. Le partite in corso non si perdono.",
      "manutenzione": "Manutenzione in corso: alcune funzioni possono non essere disponibili.",
      "manutenzioneAlle": "Manutenzione dalle {{ora}}: alcune funzioni possono non essere disponibili.",
      "rallentamenti": "Il server è più lento del solito. Ci stiamo lavorando."
    }
  },
  "nav": {
    "play": "Gioca",
    "home": "Home",
    "arena": "Arena",
    "tournaments": "Tornei",
    "leaderboard": "Classifica",
    "profile": "Profilo",
    "myGames": "Le Mie Partite",
    "logout": "Esci",
    "signIn": "Accedi",
    "backToLocal": "Torna al Gioco Locale",
    "backToTournaments": "Torna ai Tornei",
    "backToGames": "Torna alle Partite",
    "loginRequired": "Accesso richiesto",
    "faq": "FAQ e Contatti",
    "rules": "Regole",
    "editor": "Editor",
    "strumenti": "Tools"
  },
  "gara": {
    "torneoInCorso": "Torneo in corso",
    "arenaInCorso": "Arena in corso"
  },
  "strumenti": {
    "titoloFoglio": "Tools (Strumenti)",
    "orologio": "Orologio",
    "estraiApertura": "Estrai apertura"
  },
  "orologio": {
    "titolo": "Orologio dal vivo",
    "sottotitolo": "Appoggia il telefono fra i due giocatori: chi ha mosso tocca la propria metà",
    "tocca": "Tocca per iniziare",
    "pausa": "Pausa",
    "riprendi": "Riprendi",
    "azzera": "Azzera",
    "impostazioni": "Impostazioni",
    "suoni": "Suoni",
    "suonoTocco": "Suono tocco",
    "suonoPocoTempo": "Suono poco tempo",
    "tempo": "Tempo",
    "stessoTempo": "Stesso tempo per entrambi",
    "scaduto": "Tempo scaduto",
    "mosse": "Mosse"
  },
  "apertura": {
    "sottotitolo": "Sorteggia un'apertura ufficiale",
    "andataRitorno": "Questa apertura può favorire un colore: in gara si gioca andata e ritorno, a colori invertiti.",
    "estrai": "Estrai",
    "estraiDiNuovo": "Estrai di nuovo",
    "vediTabelle": "Vedi le tabelle complete",
    "posizioneIniziale": "Posizione iniziale"
  },
  "editor": {
    "title": "Editor",
    "subtitle": "Componi una posizione per studiare, analizzare o giocare",
    "boardLabel": "Damiera modificabile",
    "sideToMove": "Tratto a",
    "reset": "Reimposta",
    "clear": "Svuota",
    "flip": "Ruota",
    "playPosition": "Gioca posizione",
    "playAI": "Gioca vs Computer",
    "challenge": "Sfida un amico",
    "challengeNote": "La partita inizia dalla tua posizione ed è sempre amichevole (non valutata).",
    "tools": {
      "label": "Pezzi",
      "whiteMan": "Pedina bianca",
      "whiteKing": "Dama bianca",
      "blackMan": "Pedina nera",
      "blackKing": "Dama nera",
      "erase": "Cancella",
      "cycle": "Cambia pezzo"
    },
    "library": {
      "open": "Posizioni salvate",
      "title": "Posizioni salvate",
      "nameLabel": "Nome",
      "namePlaceholder": "Nome della posizione",
      "defaultName": "Posizione",
      "defaultNameAnalysis": "Analisi",
      "save": "Salva",
      "overwrite": "Sovrascrivi",
      "willOverwrite": "«{{name}}» verrà sostituita.",
      "saved": "In libreria",
      "empty": "Nessuna posizione salvata. Componi una posizione e salvala qui.",
      "load": "Carica {{name}}",
      "lineBadge_one": "{{count}} mossa",
      "lineBadge_other": "{{count}} mosse",
      "askLoad": "Caricare «{{name}}»? La posizione sul tavolo verrà sostituita.",
      "askLoadLine": "Carichi “{{name}}”? La posizione e la linea che stai giocando verranno sostituite.",
      "confirmLoad": "Carica",
      "rename": "Rinomina {{name}}",
      "share": "Condividi {{name}}",
      "shareCopied": "Link copiato",
      "shareTitle": "Posizione di dama",
      "shareText": "Guarda questa posizione di dama",
      "delete": "Elimina {{name}}",
      "askDelete": "Eliminare «{{name}}»?",
      "confirmDelete": "Elimina",
      "errors": {
        "nameTaken": "Esiste già una posizione con questo nome.",
        "full": "Libreria piena: elimina una posizione per salvarne un'altra.",
        "saveFailed": "Salvataggio non riuscito. Riprova.",
        "deleteFailed": "Eliminazione non riuscita. Riprova.",
        "loadFailed": "Questa posizione non è leggibile.",
        "loadListFailed": "Impossibile caricare la libreria.",
        "shareFailed": "Impossibile copiare il link."
      }
    },
    "fen": {
      "label": "Posizione (FEN)",
      "copy": "Copia FEN",
      "copied": "Copiato",
      "invalid": "FEN non valido."
    },
    "analysis": {
      "title": "Analisi",
      "hint": "Muovi entrambi i colori. Torna indietro e gioca un'altra mossa per cambiare linea.",
      "save": "Salva analisi",
      "run": "Analizza",
      "depth": "Profondità",
      "fast": "Veloce",
      "standard": "Standard",
      "deep": "Profonda",
      "evaluation": "Valutazione",
      "cancel": "Annulla",
      "reached": "Profondità raggiunta"
    },
    "invalid": {
      "noWhite": "Aggiungi almeno un pezzo bianco.",
      "noBlack": "Aggiungi almeno un pezzo nero.",
      "manOnPromotionRow": "Una pedina non può stare sulla riga di promozione: rendila dama o spostala.",
      "tooManyPieces": "Troppi pezzi per questa variante.",
      "sideToMoveNoMoves": "Il giocatore di turno non ha mosse legali.",
      "alreadyTerminal": "Questa posizione è già decisa (vinta o patta).",
      "offBoard": "Un pezzo sta su una casella che questa variante non ha.",
      "duplicateSquare": "Due pezzi sulla stessa casella."
    }
  },
  "rules": {
    "channels": {
      "cta": "Canali consigliati",
      "title": "Canali consigliati",
      "note": "Canali che consigliamo per guardare e studiare questa variante.",
      "opensOnYouTube": "Si apre su YouTube"
    },
    "backToRules": "Tutte le regole",
    "playOnline": "Gioca subito",
    "playAI": "Gioca col computer",
    "indexTitle": "Regole della dama",
    "indexIntro": "Due regolamenti in un posto solo: le regole di gioco di ogni variante supportata, e le regole con cui girano i nostri tornei online.",
    "gameTitle": "Regole della dama per variante",
    "gameIntro": "La dama — conosciuta anche come draughts, checkers, dammen e damas — si gioca in tutto il mondo, ogni regione con le sue regole. Sfoglia qui sotto le regole di ogni variante supportata.",
    "gameCtaDesc": "Scacchiera, mosse, prese e promozione — variante per variante.",
    "heroSubtitle": "Regole, disposizione iniziale e come si gioca a {{variant}}.",
    "startingPosition": "Posizione iniziale",
    "howToPlay": "Come si gioca",
    "otherVariants": "Altre varianti",
    "eyebrow": "Regole",
    "glance": {
      "title": "A colpo d'occhio",
      "board": "Damiera",
      "pieces": "Pezzi per lato",
      "starts": "Inizia"
    },
    "theme": {
      "movement": "Movimento",
      "capture": "Catture",
      "promotion": "Promozione"
    },
    "variantsLabel": "Varianti",
    "draughtsWord": "dama",
    "tournaments": {
      "title": "Regole dei tornei",
      "heroSubtitle": "Tutto quello che un torneo decide da sé, dal numero di turni agli spareggi.",
      "intro": "Un torneo, una volta partito, va avanti da sé: conta gli iscritti presenti, sceglie il sistema di accoppiamento, fissa il numero di turni e stila la classifica. Queste sono le regole che applica, nell’ordine in cui le applica.",
      "source": "Fonte: FIDE C.04.1 e FMJD Annex 3, adattati al gioco online.",
      "cta": "Come funziona un torneo",
      "ctaDesc": "Formato, turni, iscrizione, assenze, spareggi e arena.",
      "chaptersLabel": "Capitoli",
      "format": {
        "title": "Formato",
        "body": [
          "Un solo torneo a turni, il girone-svizzero: chi apre un torneo non sceglie fra girone e sistema svizzero, sceglie una soglia di iscritti. Accanto ai tornei c'è l'arena, che è un'altra cosa: vedi il capitolo «L'arena».",
          "All'ora d'inizio si contano gli iscritti che ci sono davvero. Sotto la soglia si gioca un girone all'italiana: tutti contro tutti, con il calendario di Berger. Dalla soglia in su si gioca a sistema svizzero: a ogni turno si viene accoppiati con chi ha il tuo stesso punteggio, e non si affronta mai due volte lo stesso avversario.",
          "La soglia predefinita è 7 e si può impostare fra 7 e 20; il girone arriva al massimo a 19 iscritti.",
          "Il motivo è semplice: quando un torneo si apre non si sa quanti verranno, e scegliere prima il formato vuol dire sceglierlo alla cieca.",
          "Vittoria 2 punti, patta 1 punto, sconfitta zero. Se gli iscritti sono in numero dispari, a ogni turno uno riposa, e quanto vale quel riposo dipende dal formato: nello svizzero vale 2 punti come una vittoria — 4 in un torneo di andata e ritorno, dove ogni turno sono due partite — mentre nel girone non dà punti, perché lì tutti incontrano tutti e il riposo è soltanto un turno che non si gioca. In nessuno dei due casi conta come partita vinta, e in nessuno dei due entra negli spareggi."
        ]
      },
      "rounds": {
        "title": "Numero di turni",
        "body": [
          "Li fissa l'inizio del torneo, contando gli iscritti presenti. Con la soglia predefinita, per numero di iscritti:",
          "Un torneo accetta al massimo 200 iscritti, quindi dieci turni sono il massimo — undici col turno extra.",
          "Nel girone i turni sono quelli che servono perché ciascuno incontri tutti gli altri. Con tre o quattro iscritti l'andata e ritorno si gioca sempre, qualunque cosa abbia scelto chi ha aperto il torneo: ogni turno diventa così di due partite, perché con una sola partita per avversario una sconfitta al primo turno deciderebbe già il torneo. In quattro sono tre turni e sei partite a testa; in tre si gioca sugli stessi tre turni ma uno riposa ogni volta, quindi ciascuno riposa una volta e gioca quattro partite — e il turno di riposo non dà punti.",
          "Nello svizzero, raddoppiando il campo si aggiunge un turno: ogni turno dimezza il numero di chi può ancora chiudere a punteggio pieno. È un turno in più di quanti ne basterebbero a un torneo a eliminazione, perché altrimenti due giocatori resterebbero appaiati in testa senza essersi mai incontrati.",
          "Due interruttori cambiano il conto. Il «turno extra» ne aggiunge uno alla tabella quando il campo lo regge, e vale solo se all'inizio esce uno svizzero: in un girone tutti si incontrano già, e un turno in più sarebbe soltanto una rivincita per tutti. L'«andata e ritorno» invece non aggiunge turni, li riempie: ogni accoppiamento si gioca due volte di fila, a colori invertiti e sulla stessa apertura, dentro lo stesso turno, che quindi dura il doppio. Funziona allo stesso modo nel girone e nello svizzero, e i punti restano per partita: una vittoria e una patta fanno 3, due vittorie 4."
        ],
        "rounds": [
          "3-4 — girone, 3 turni",
          "5-6 — girone, 5 turni",
          "7-8 — svizzero, 4 turni",
          "9-16 — svizzero, 5 turni",
          "17-32 — svizzero, 6 turni",
          "33-64 — svizzero, 7 turni",
          "65-128 — svizzero, 8 turni",
          "129-192 — svizzero, 9 turni",
          "193-200 — svizzero, 10 turni"
        ]
      },
      "entry": {
        "title": "Iscrizione e ritiro",
        "body": [
          "Aprire un torneo lo può chiunque abbia un account registrato: non serve un permesso e non c'è un organizzatore ufficiale. Gli ospiti e i computer nei tornei non entrano, né per aprirli né per giocarli.",
          "Tre gare vive per persona: puoi tenere aperti fino a tre tornei o arene insieme, e per aprirne un'altra devi aspettare che una sia finita, oppure annullarla.",
          "Un torneo si programma, non si fa partire a mano: l'inizio si fissa fra cinque minuti e quattordici giorni. Chi lo apre lo organizza e basta: per giocarci deve premere «Iscriviti» sulla pagina del torneo, come tutti gli altri, e finché non lo fa non fa numero — un minimo di 3 vuole tre persone oltre a lui.",
          "I posti vanno da 3 a 200. Il minimo per partire è 3, e chi apre può alzarlo: se all'ora d'inizio gli iscritti sono meno del minimo, il torneo si annulla da solo. Finché non è partito chi l'ha aperto può annullarlo; dopo no, perché chi sta giocando ha diritto di finire.",
          "Un torneo può essere privato: si entra solo con la password che chi l'ha aperto ha scelto, o con il link d'invito.",
          "Ci si iscrive fino a quando parte il primo turno, e fino a lì ci si può anche ritirare — chi annulla l'iscrizione prima dell'inizio sparisce subito dalla classifica, perché non ha ancora giocato niente. Da lì in poi la porta si chiude in tutti e due i versi: chi è dentro resta in tabellone, perché ritirarsi a metà lascerebbe un avversario senza partita a ogni turno che manca."
        ]
      },
      "absences": {
        "title": "Assenze",
        "body": [
          "Dipende da dov'eri, e i tre casi finiscono in tre modi diversi.",
          "Se sei semplicemente scollegato, la partita si apre lo stesso e il tuo orologio parte. Arrivare con tre minuti di ritardo vuol dire giocare con tre minuti in meno, non perdere la partita: solo se non arrivi mai perdi per tempo scaduto. Una partita a cui uno dei due non si è mai seduto non muove il punteggio di nessuno dei due.",
          "Lo stesso vale se ti colleghi e la connessione cade prima della tua prima mossa: decide il tuo orologio. Dopo la prima mossa invece, se cadi, hai 30 secondi per rientrare, come in ogni partita.",
          "Se invece sei già impegnato in un'altra partita — un'arena, una sfida, un altro torneo — la partita del turno non si apre affatto e prendi una sconfitta a tavolino, con i 2 punti al tuo avversario. Non è una punizione: aprirti una seconda damiera renderebbe irraggiungibile quella dove stai già giocando.",
          "Se mancate in due, il turno si chiude 0-0 e nessuno prende niente. Una patta d'ufficio premierebbe l'assenza.",
          "In nessuno dei tre casi si viene esclusi: al turno dopo si viene accoppiati come sempre.",
          "Un'ultima cosa vale per tutti: un torneo ha una durata annunciata, e se a quell'ora ci sono ancora partite in corso si aspettano dieci minuti. Passati quelli il torneo chiude e le partite ancora aperte sono date patte."
        ]
      },
      "openingMoves": {
        "title": "Apertura delle partite",
        "body": [
          "Dipende da come è stato aperto il torneo, e i modi sono nove.",
          "«Mossa libera» è quella normale: si gioca dalla prima mossa, e nessuno impone niente.",
          "Poi ci sono i sorteggi. Tre impongono una, due o tre mosse a caso fra quelle legali, e valgono su ogni variante. Altri quattro pescano invece da una tabella ufficiale F.I.D., e ci sono solo su italiana e inglese, le due varianti che hanno una tabella federale: quello che si sceglie è quanto squilibrata può essere l'apertura che esce — fino a 1N/1B, fino a 2N/2B, fino a 3N/3B, oppure tutte e 174. In uno svizzero la stessa apertura non esce due volte nello stesso torneo.",
          "E poi c'è il torneo a tema: chi apre sceglie UNA delle 174 aperture ufficiali, e la giocano tutti, in tutti i turni e in tutte le partite. È l'unico caso in cui l'apertura si conosce prima di cominciare, e l'unico in cui la regola «mai due volte la stessa» non vale — sarebbe esattamente il contrario di quello che un torneo a tema chiede.",
          "Con l'andata e ritorno le due partite di un turno si giocano sulla stessa apertura a colori invertiti: è il modo in cui un'apertura squilibrata smette di favorire qualcuno."
        ]
      },
      "rated": {
        "title": "Tornei valutati",
        "body": [
          "Se il torneo è valutato sì, e non in una classifica a parte: le partite di torneo muovono lo stesso punteggio di tutte le altre, quello della variante e della cadenza in cui si gioca. Lo decide chi apre il torneo, e di norma è valutato.",
          "Un torneo o un'arena valutati possono avere uno sbarramento, cioè un punteggio minimo per entrare, a scalini da 1000 fino a 2000: si misura sul punteggio di quella variante e di quella cadenza, non su un punteggio generale. Negli amichevoli lo sbarramento non esiste, perché il punteggio non si muove e non c'è niente da proteggere. Tetti non ce ne sono: nessuno resta fuori perché è troppo forte.",
          "C'è poi una cosa che può spegnere il valutato da sé, ed è l'apertura. La regola federale dice che una partita sola basta finché l'apertura arriva al 2N/2B; da lì in su il vantaggio di un colore è troppo grande perché una partita secca lo compensi, e serve l'andata e ritorno. Vale in tutti e due i modi: su un sorteggio conta il tetto della tabella da cui si pesca, su un torneo a tema conta la forza dell'apertura scelta, che lì si sa già. Se la combinazione non regge, il torneo nasce amichevole invece di essere rifiutato — e accendere l'andata e ritorno lo riporta valutato.",
          "Non sono valutate, infine, le partite a cui uno dei due non si è mai seduto."
        ]
      },
      "tiebreaks": {
        "title": "Spareggi",
        "body": [
          "Dipende dal formato.",
          "Nel sistema svizzero, in quest'ordine:",
          "1. Buchholz Cut 1: la somma dei punti finali di tutti gli avversari affrontati, tolto il più debole. Premia chi ha avuto il cammino più duro. Il turno di riposo non entra nel conto, perché non è un avversario.",
          "2. Sonneborn-Berger: i punti di chi hai battuto, più metà dei punti di chi hai pattato. Premia chi ha battuto i più forti.",
          "3. Il numero di vittorie.",
          "4. La variazione di rating nel torneo: quanti punti di rating hai guadagnato o perso nelle partite di questo torneo. Premia chi ha reso più del previsto, non chi era già più forte. Chi è pari anche qui condivide il posto.",
          "In classifica Buchholz e Sonneborn-Berger vengono dopo vittorie, patte, sconfitte e riposi, abbreviati in BH e SB.",
          "Nel girone gli spareggi sono altri, perché tutti incontrano tutti e il Buchholz non distinguerebbe nessuno: prima il numero di vittorie, poi lo scontro diretto fra i soli giocatori a pari punti, poi il Sonneborn-Berger (SB), infine la variazione di rating nel torneo. Se sono ancora pari, passa davanti chi ha il posto migliore nel calendario, cioè il rating più alto all'inizio del torneo: nel girone non ci sono pari merito. BH nel girone non si mostra, perché affrontando tutti sarebbe il rovescio dei punti. In classifica «SD»: accanto al nome di chi passa davanti per lo scontro diretto.",
          "Nell'arena non ci sono turni e il Buchholz non si potrebbe calcolare: a pari punti decidono il numero di vittorie, poi lo scontro diretto fra i pari punti, poi la media dei punti degli avversari affrontati — la media e non la somma, perché in arena si gioca un numero di partite molto diverso — e infine chi ha fatto gli stessi punti in meno partite. In classifica i due numeri compaiono solo sulle righe in parità, dove servono: «SD» è lo scontro diretto, «Avversari» la loro media."
        ]
      },
      "sharedPlaces": {
        "title": "Pari merito",
        "body": [
          "Nello svizzero capita nei tornei piccoli, quando tutte le partite finiscono in patta: stessi punti, stesso Buchholz, stesso Sonneborn-Berger, nessuna vittoria per nessuno.",
          "In quel caso la posizione è condivisa. Due primi a pari merito prendono tutti e due l'oro, e il posto successivo è il terzo: 1, 1, 3, come in ogni classifica sportiva. Nessuno viene messo davanti a un altro per il punteggio Elo o per l'ora di iscrizione.",
          "Una sola avvertenza: all'albo d'oro del torneo resta registrato un nome solo, perché quella casella ne accetta uno. La classifica e il podio mostrano tutti i pari merito."
        ]
      },
      "arena": {
        "title": "L'arena",
        "body": [
          "L'altra gara che si può aprire, e non è un torneo a turni: non ha né turni né calendario, ha una durata. Si apre, dura da dieci minuti a otto ore, e finché è aperta si viene riaccoppiati appena si finisce, senza aspettare che gli altri finiscano la loro partita. Si entra e si esce quando si vuole, anche a gara iniziata.",
          "Con la stessa persona però si aspetta: cinque minuti per ogni partita già giocata insieme. La prima rivincita arriva dopo cinque minuti, la seconda dopo dieci, la terza dopo quindici, e non c'è un tetto. Serve a evitare che un'arena diventi la stessa sfida ripetuta a oltranza.",
          "Punteggio: vittoria 2, patta 1, sconfitta zero, come nel torneo.",
          "E c'è il boost, da prendere prima della propria prima mossa: raddoppia i punti di una vittoria e si paga con l'orologio — l'incremento se ne va tutto, e il tempo base si dimezza. È una scommessa, non un regalo.",
          "A pari punti decidono, in quest'ordine: chi ha vinto più partite; poi lo scontro diretto fra i soli giocatori a pari punti e pari vittorie; poi la forza degli avversari affrontati, cioè la media dei loro punti — la media e non la somma, perché in arena si gioca un numero di partite molto diverso e una somma premierebbe solo chi ne gioca di più; infine chi è arrivato agli stessi punti in meno partite. Le partite interrotte non entrano nel conto, e chi è pari anche sull'ultimo criterio condivide il posto: un'arena può avere due vincitori."
        ]
      }
    },
    "seo": {
      "title": "{{variant}}: regole e come si gioca",
      "description": "Impara le regole di {{variant}}: dimensione della damiera, posizione iniziale, come muovono e catturano pedine e dame, e come si vince. Gioca a {{draughtsWord}} online gratis.",
      "indexTitle": "Regole della dama — regole di gioco e regole dei tornei",
      "indexDescription": "Due regolamenti per la {{draughtsWord}}: le regole di gioco di ogni variante — internazionale, italiana, turca, frisone e altre — e le regole dei nostri tornei online.",
      "gameTitle": "Regole della dama per variante — come si gioca",
      "gameDescription": "Regole e guide per ogni variante di {{draughtsWord}}: internazionale, italiana, turca, frisone, brasiliana e molte altre. Gioca online gratis.",
      "openingsTitle": "{{variant}}: tabelle di apertura ufficiali F.I.D.",
      "openingsDescription": "Tutte le 174 aperture ufficiali di {{variant}} con valutazione e tabelle federali A, B, C e D. Regolamento Tecnico F.I.D. 2025.",
      "captureTitle": "{{variant}}: regole di presa complete",
      "captureDescription": "Tutte le regole di presa di {{variant}}: presa obbligatoria, presa multipla, la gerarchia che decide quale presa fare, promozione. Con esempi sulla damiera.",
      "tournamentsTitle": "Regole dei tornei — come funziona un torneo di {{draughtsWord}}",
      "tournamentsDescription": "Le regole dei tornei di {{draughtsWord}} online: formato girone-svizzero, numero di turni, iscrizione e ritiro, assenze, sorteggio dell’apertura, punteggio, spareggi e arena."
    },
    "fact": {
      "board": "Si gioca su una damiera {{size}}×{{size}}, solo sulle caselle scure.",
      "boardAllSquares": "Si gioca su una damiera {{size}}×{{size}}, usando tutte le caselle.",
      "pieces": "Ogni giocatore inizia con {{count}} pezzi.",
      "startsWhite": "Muove per primo il Bianco.",
      "startsBlack": "Muove per primo il Nero.",
      "moveDiagonal": "Le pedine si muovono in diagonale in avanti, una casella alla volta.",
      "moveOrthogonal": "Le pedine si muovono in ortogonale — avanti e di lato — una casella alla volta.",
      "captureDiagonal": "Le catture si effettuano in diagonale, scavalcando un pezzo avversario adiacente.",
      "captureOrthogonal": "Le catture si effettuano in ortogonale, scavalcando un pezzo avversario adiacente.",
      "captureMixed": "Le catture si possono effettuare sia in diagonale sia in ortogonale.",
      "menCaptureBackwardYes": "Le pedine possono catturare sia in avanti sia all'indietro.",
      "menCaptureBackwardNo": "Le pedine possono catturare solo in avanti.",
      "kingFlying": "Le dame sono \"volanti\": muovono e catturano lungo una linea attraverso un numero qualsiasi di caselle vuote.",
      "kingShort": "Le dame muovono una casella alla volta (niente dame volanti).",
      "menCaptureKingYes": "Le pedine possono catturare le dame.",
      "menCaptureKingNo": "Le pedine non possono catturare le dame.",
      "maxCapturePieces": "La cattura è obbligatoria e si deve eseguire la sequenza che cattura il maggior numero di pezzi.",
      "maxCaptureValue": "La cattura è obbligatoria e si deve eseguire la sequenza di maggior valore: una dama vale più di una pedina, ma due pedine valgono più di una dama.",
      "captureMandatoryFree": "La cattura è obbligatoria, ma si può scegliere liberamente quale eseguire.",
      "kingPriorityTie": "A parità di presa, si deve catturare con la dama e non con la pedina.",
      "maxKingsCaptureTie": "A parità di numero di pezzi, si deve eseguire la sequenza che cattura il maggior numero di dame.",
      "firstKingFirst": "A parità ulteriore, si deve prendere la sequenza in cui la dama o le dame vengono prima.",
      "huffing": "Si applica la regola del \"soffio\": un pezzo che non ha catturato può essere rimosso.",
      "captureImmediateRemoval": "Ogni pezzo catturato viene rimosso subito dalla damiera: questo può aprire ulteriori catture nella stessa sequenza.",
      "captureNoReversal": "Durante una cattura multipla si può proseguire dritto o svoltare di 90°, ma mai invertire la direzione di 180° tra due salti.",
      "promotionStops": "Una pedina che raggiunge l'ultima traversa è promossa e la mossa termina, anche durante una cattura.",
      "promotionContinues": "Una pedina che attraversa l'ultima traversa durante una cattura resta pedina e prosegue la presa; si promuove solo se la mossa termina sull'ultima traversa.",
      "promotionInPassing": "Una pedina che raggiunge l'ultima traversa durante una cattura diventa subito dama e prosegue la presa nello stesso turno come dama volante.",
      "blockedKing": "Finché ha pedine in campo, un giocatore non può fare più di {{n}} mosse semplici consecutive con la stessa dama; la dama bloccata può però catturare.",
      "frisianEndgame": "Si applicano le regole frisone di patta nel finale (es. due dame contro una è patta dopo un certo numero di mosse).",
      "loneKingWins": "Se un giocatore resta con una sola pedina contro la dama avversaria, la vittoria è assegnata a chi ha la dama.",
      "singlePieceLoses": "Chi resta con un solo pezzo — pedina o dama — perde immediatamente la partita.",
      "drawLimit": "La partita è patta dopo {{n}} mosse in cui si muovono solo le dame, senza catture."
    },
    "openings": {
      "title": "Tabelle di apertura",
      "heroSubtitle": "Le 174 aperture ufficiali di {{variant}}, con la valutazione e la tabella federale di appartenenza.",
      "source": "Fonte: Regolamento Tecnico F.I.D., gennaio 2025.",
      "cta": "Tabelle di apertura",
      "ctaDesc": "Le 174 aperture ufficiali con la loro valutazione.",
      "intro": "Nelle gare ufficiali le prime tre semi-mosse non si scelgono: si sorteggiano da una tabella. La Tabella Generale raccoglie tutte le 174 aperture; le tabelle federali A, B, C e D ne sono sottoinsiemi, usati a seconda del tipo di incontro.",
      "ratedNote": "Nelle sfide dirette puoi sorteggiare l’apertura entro una soglia di forza: fino a 2N/2B una sola partita resta valutata, oltre serve andata e ritorno.",
      "tableAll": "Generale",
      "tableA": "Tabella A",
      "tableB": "Tabella B",
      "tableC": "Tabella C",
      "tableD": "Tabella D",
      "count": "{{count}} aperture",
      "colNumber": "N°",
      "colOpening": "Apertura",
      "colStrength": "Valutazione",
      "colStrengthShort": "Val.",
      "colTables": "Tabelle",
      "colTablesShort": "Tab.",
      "firstMove": "Prima mossa {{move}}",
      "legendTitle": "Come si legge la valutazione",
      "legendColours": "N = Nero, B = Bianco.",
      "legendPari": "PARI — gioco equilibrato.",
      "legend1": "1N / 1B — il colore sta leggermente meglio, con più scelte di linee.",
      "legend2": "2N / 2B — il colore sta decisamente meglio e l’avversario gioca in difensiva.",
      "legend3": "3N / 3B — il colore è formidabile: l’avversario ha bisogno di manovre esperte per pattare.",
      "legend4": "4N / 4B — il colore è considerato vincente secondo le conoscenze attuali.",
      "tablesTitle": "Le tabelle federali",
      "italianA": "Solo incontri su due partite o gare a coppie e a squadre.",
      "italianB": "Tabella di default delle gare ufficiali; utilizzabile anche in una sola partita.",
      "italianC": "Sottoinsieme della B per categorie giovanili, provinciali e tornei promozionali.",
      "italianD": "Le aperture considerate vincenti: solo incontri su due partite.",
      "englishA": "Tabella normalmente usata negli incontri su due partite e nelle gare a squadre.",
      "englishB": "Tornei con incontri di una sola partita.",
      "englishC": "Sottoinsieme della B per casi particolari previsti dai regolamenti di gara.",
      "englishD": "Le aperture considerate vincenti: solo incontri su due partite.",
      "tableEvery": "Tutte",
      "everyTitle": "Perché 302 aperture diventano 174",
      "everyIntro": "Le aperture legali in tre semi-mosse sono {{total}}, ma portano solo a {{positions}} posizioni diverse: la Tabella Generale ne sceglie {{listed}}, una per posizione. Ecco perché le altre restano fuori.",
      "status_ballot": "In tabella",
      "statusBallotDesc": "Sorteggiabile: è una delle aperture ufficiali.",
      "statusTransposition": "Come la n. {{id}}",
      "statusTranspositionShort": "Trasposizione",
      "statusTranspositionDesc": "Stessa posizione finale di un’apertura già in tabella, raggiunta cambiando l’ordine delle mosse: sarebbe la stessa partita con un altro nome.",
      "status_material": "Perde un pezzo",
      "statusMaterialDesc": "Dopo la terza semi-mossa un colore resta con un pezzo in meno e non ha alcuna ripresa: sono le due combinazioni che il regolamento esclude da sempre.",
      "status_unlisted": "Fuori tabella",
      "statusUnlistedDesc": "Posizione che la tabella non copre affatto. Non c’è una ragione meccanica: è una scelta tecnica della federazione, che ha selezionato le linee da studiare.",
      "statusDecidedDesc": "Restano in tabella ma solo per incontri su due partite: sono considerate vincenti per il colore avvantaggiato, quindi perdenti per l’altro.",
      "colPosition": "Posizione"
    },
    "capture": {
      "cta": "Le regole di presa",
      "ctaDesc": "La gerarchia delle prese, passo per passo, con gli esempi.",
      "title": "Regole di presa",
      "heroSubtitle": "Quando la presa è obbligatoria, quale presa si deve fare e come si conta, a {{variant}}.",
      "intro": "La presa è la parte più regolata del gioco. Non basta sapere come si cattura: bisogna sapere quale cattura si è obbligati a fare. Qui trovi ogni regola, nell’ordine esatto in cui il gioco la applica.",
      "source": "Fonte: Regolamento Tecnico F.I.D., gennaio 2025.",
      "mandatoryTitle": "La presa è obbligatoria",
      "mandatoryBody": "Se al proprio turno esiste anche una sola presa, tutte le mosse tranquille spariscono: non sono mosse sbagliate, semplicemente non esistono. L’obbligo riguarda l’intera posizione, non il singolo pezzo.",
      "mandatoryRejected": "Non c’è penalità per chi sbaglia: una presa che non rispetta le regole viene rifiutata e la posizione resta com’era.",
      "geometryTitle": "Come si cattura",
      "geometryShortKing": "Anche la dama salta una sola casella: deve avere il pezzo avversario immediatamente vicino in diagonale.",
      "geometryLanding": "La casella dietro il pezzo catturato deve essere libera. Se è occupata, da un pezzo qualsiasi, o se è fuori dalla damiera, quella presa non esiste.",
      "menVsKingTitle": "Pedine e dame",
      "menVsKingWall": "Per una pedina la dama avversaria è un muro: non la può catturare e non la può scavalcare. Una dama piazzata davanti a un gruppo di pezzi li rende intoccabili dalle pedine.",
      "menVsKingFree": "Non ci sono restrizioni di qualità: qualsiasi pezzo può catturare qualsiasi pezzo.",
      "multiTitle": "La presa multipla",
      "multiBody": "Se dopo un salto il pezzo si trova di nuovo davanti a un pezzo catturabile, deve proseguire. Fermarsi a metà non è una scelta: la sequenza incompleta non è una mossa legale.",
      "multiDirection": "A ogni salto si può cambiare direzione. La pedina però alterna solo le due diagonali in avanti: durante la sequenza non acquista mai la presa all’indietro.",
      "multiNoTwice": "Lo stesso pezzo avversario non si può saltare due volte nella stessa sequenza. Sulla stessa casella vuota, invece, si può ripassare quante volte serve.",
      "ladderTitle": "La gerarchia delle prese",
      "ladderIntro": "Quando le prese possibili sono più di una, non si sceglie liberamente. Il gioco le confronta con questi criteri, in quest’ordine: si passa al criterio successivo solo se il precedente lascia più prese in parità.",
      "ladderWholePosition": "Il confronto è fra tutte le prese di tutti i propri pezzi. Un pezzo può quindi restare fermo perché un altro pezzo ha una presa migliore.",
      "ladderNoneIntro": "La presa è obbligatoria, ma quale presa fare è una scelta libera. Non esiste alcuna gerarchia: una presa singola vale quanto una presa multipla, e nessun criterio impone di catturare di più.",
      "levelLabel": "Livello {{n}}",
      "levelMaxPieces": "Si deve eseguire la presa che cattura il maggior numero di pezzi.",
      "whyMaxPieces": "Si contano i pezzi, non il loro valore: due pedine battono una dama.",
      "levelMaxValue": "Si deve eseguire la presa di valore complessivo più alto.",
      "whyMaxValue": "Le dame pesano più delle pedine, quindi non vince sempre la sequenza più lunga.",
      "levelWithKing": "A parità di pezzi catturati, si deve catturare con la dama e non con la pedina.",
      "whyWithKing": "Il criterio riguarda il pezzo che cattura, non quello catturato. Se una dama e una pedina prendono lo stesso numero di pezzi, tocca alla dama, anche quando la pedina prenderebbe pezzi più preziosi.",
      "levelMaxKings": "A parità ulteriore, si deve eseguire la presa che cattura il maggior numero di dame.",
      "whyMaxKings": "Qui conta il valore di ciò che si toglie all’avversario. Poiché solo le dame possono catturare le dame, questo criterio distingue soltanto fra prese di dama.",
      "levelFirstKing": "A parità ulteriore, si deve prendere la sequenza in cui la dama o le dame vengono prima.",
      "whyFirstKing": "Si guarda l’ordine dei salti: vince il percorso che incontra la prima dama al salto più basso; se coincide si guarda la seconda dama, poi la terza. La scelta resta libera solo se le dame cadono negli stessi salti.",
      "levelFree": "Se le prese restano equivalenti, la scelta è libera.",
      "whyFree": "Oltre questo punto nessuna regola vincola il giocatore: due prese identiche su tutti i criteri si possono giocare indifferentemente.",
      "removalTitle": "Quando si tolgono i pezzi",
      "removalEnd": "I pezzi catturati restano sulla damiera fino alla fine della mossa e si tolgono tutti insieme quando la sequenza è completa. È per questo che, durante una presa multipla, li vedi ancora al loro posto.",
      "removalImmediate": "La casella liberata torna disponibile subito. Resta comunque vietato saltare due volte lo stesso pezzo.",
      "promotionTitle": "La promozione ferma la presa",
      "promotionBody": "Se durante una sequenza la pedina arriva sull’ultima traversa, la mossa finisce lì: la pedina diventa dama e il turno passa all’avversario, anche se da quella casella ci sarebbero altri salti. La nuova dama muove dal turno successivo.",
      "promotionNoExemption": "La promozione non esonera dalla gerarchia: la sequenza interrotta entra nel confronto con i pezzi che ha davvero catturato. Se un’altra presa ne cattura di più, quella che promuove è illegale.",
      "promotionStillAMan": "Ai fini della gerarchia la pedina che si promuove conta ancora come pedina: non acquista la priorità della dama.",
      "noHuffingTitle": "Niente soffio",
      "noHuffingBody": "La regola del \"soffio\" non si applica: chi non esegue la presa dovuta non perde il pezzo, semplicemente non può giocare quella mossa.",
      "exGeometry": "Il Bianco scavalca il pezzo vicino e atterra subito dietro.",
      "exMenVsKingWall": "La pedina è accanto alla dama avversaria e non può catturarla: le resta solo una mossa tranquilla.",
      "exMenVsKingFree": "Qui la pedina cattura la dama come farebbe con qualsiasi altro pezzo.",
      "exMulti": "Una sola mossa legale: la sequenza va completata fino in fondo.",
      "exPromotion": "Il Bianco arriva sull’ultima traversa: la mossa finisce lì, anche se resterebbe un pezzo da prendere.",
      "exMaxPieces": "Due prese disponibili: una cattura un pezzo, l’altra due. Solo la più lunga è legale.",
      "exMaxValue": "Fra le prese possibili conta il valore complessivo dei pezzi catturati.",
      "exWithKing": "La dama e la pedina catturano un pezzo ciascuna: si deve muovere la dama.",
      "exMaxKings": "Due dame possono catturare: si deve prendere la dama avversaria, non la pedina.",
      "exFirstKing": "Due percorsi da due pezzi con una dama ciascuno: è obbligatorio quello che prende la dama per primo.",
      "exFree": "Il primo salto è obbligato, poi la presa si biforca: due pezzi per ramo, e la scelta è tua.",
      "exFreeNoLadder": "Una presa cattura un pezzo, l’altra due: qui sono legali entrambe.",
      "forced": "Mossa obbligatoria",
      "choices": "Mosse legali",
      "diagramAlt": "Posizione d’esempio"
    },
    "gameRulesHead": "Regole di gioco"
  },
  "faq": {
    "title": "FAQ e Contatti",
    "intro": "Domande frequenti e un canale diretto per problemi, richieste e segnalazioni.",
    "questionsTitle": "Domande frequenti",
    "entries": [
      {
        "id": "install-android",
        "q": "Come installo l'app su Android?",
        "a": "L'app si installa direttamente dal browser: non serve il Play Store.\n1. Apri il sito con Chrome (o Edge, Samsung Internet).\n2. Tocca il menu ⋮ in alto a destra.\n3. Scegli \"Installa app\" (oppure \"Aggiungi a schermata Home\") e conferma.\nA volte è il browser stesso a proporre un banner di installazione: puoi usare anche quello. L'icona compare insieme alle tue altre app e il gioco si apre a schermo intero, senza la barra del browser."
      },
      {
        "id": "install-ios",
        "q": "Come installo l'app su iPhone o iPad?",
        "a": "Su iPhone e iPad la procedura è diversa e va fatta da Safari.\n1. Apri il sito con Safari (con altri browser la voce può non comparire).\n2. Tocca il pulsante Condividi (il quadrato con la freccia verso l'alto): in basso su iPhone, in alto su iPad.\n3. Scorri l'elenco e scegli \"Aggiungi a Home\".\n4. Tocca \"Aggiungi\" in alto a destra.\niOS non mostra mai un avviso automatico di installazione: senza questi passaggi l'icona non viene creata."
      },
      {
        "id": "install-desktop",
        "q": "Posso installare l'app sul computer?",
        "a": "Sì, con Chrome o Edge.\n1. Apri il sito.\n2. Clicca l'icona di installazione a destra nella barra degli indirizzi, oppure apri il menu del browser e scegli \"Installa…\".\n3. Conferma: l'app si apre in una finestra dedicata, senza la barra del browser.\nFirefox e Safari su computer non supportano l'installazione: puoi comunque giocare normalmente dal browser e salvare il sito nei preferiti."
      },
      {
        "id": "login",
        "q": "Non riesco ad accedere al mio account, cosa devo fare?",
        "a": "Verifica di aver inserito email e password corrette. Se hai dimenticato la password, usa il link \"Password dimenticata\" nella schermata di accesso. Se il problema persiste, compila il modulo qui sotto e seleziona la categoria \"Problema di accesso\"."
      },
      {
        "id": "verify-email",
        "q": "Non ho ricevuto l'email di verifica, come posso riceverla di nuovo?",
        "a": "Apri la finestra di accesso, prova ad accedere con le tue credenziali e clicca su \"Invia di nuovo email di verifica\". Controlla anche la cartella spam."
      },
      {
        "id": "variant-request",
        "q": "Posso suggerire una nuova variante di dama?",
        "a": "Sì! Compila il modulo di contatto qui sotto, seleziona \"Richiesta nuova variante\" e descrivi le regole della variante che vorresti vedere supportata."
      },
      {
        "id": "rules-wrong",
        "q": "Le regole di una variante mi sembrano sbagliate, come segnalarlo?",
        "a": "Compila il modulo di contatto qui sotto e seleziona \"Regole non corrette\". Indica la variante interessata e descrivi nel dettaglio la regola da correggere, possibilmente con un riferimento alla fonte ufficiale (FMJD, FID, WCDF, ecc.)."
      },
      {
        "id": "delete-account",
        "q": "Come posso eliminare il mio account?",
        "a": "Apri le impostazioni del profilo: troverai le opzioni per esportare i tuoi dati (GDPR) e per eliminare definitivamente l'account. L'eliminazione è irreversibile."
      }
    ],
    "contactTitle": "Contattaci",
    "contactIntro": "Non hai trovato la risposta? Scrivici e ti risponderemo via email.",
    "category": {
      "login": "Problema di accesso",
      "variant_request": "Richiesta nuova variante",
      "rules": "Regole non corrette",
      "other": "Altro"
    },
    "fields": {
      "name": "Nome (facoltativo)",
      "email": "Email",
      "category": "Categoria",
      "subject": "Oggetto",
      "message": "Messaggio"
    },
    "submit": "Invia richiesta",
    "success": "Grazie! La tua richiesta è stata inviata. Ti risponderemo via email il prima possibile.",
    "errors": {
      "invalidEmail": "Inserisci un indirizzo email valido.",
      "subjectTooShort": "L'oggetto deve contenere almeno 3 caratteri.",
      "messageTooShort": "Il messaggio deve contenere almeno 10 caratteri.",
      "rateLimited": "Hai inviato troppe richieste in poco tempo. Riprova tra un'ora.",
      "submitFailed": "Invio fallito. Verifica la connessione e riprova."
    }
  },
  "home": {
    "heroTitle": "Dama Online",
    "heroTagline": "La piattaforma di dama internazionale, italiana e inglese. Gioca, competi nei tornei e scala la classifica.",
    "welcome": "Benvenuto",
    "newGame": "Nuova Partita",
    "chooseMode": "Scegli la modalità di gioco",
    "startNow": "Gioca",
    "vsAI": "Gioca vs IA",
    "vsAIDesc": "Allenati contro il computer",
    "vsOnline": "Gioca Online",
    "vsOnlineDesc": "Sfida giocatori reali",
    "vsFriends": "Gioca con Amici",
    "vsFriendsDesc": "Crea o unisciti a una partita privata",
    "createTable": "Crea Tavolo",
    "createTableDesc": "Invita un amico a giocare",
    "joinTable": "Unisciti",
    "joinTableDesc": "Inserisci un codice stanza",
    "enterRoomCode": "Inserisci il codice stanza condiviso dal tuo amico",
    "variant": "Variante",
    "difficulty": "Difficoltà",
    "timeControl": "Controllo Tempo",
    "startGame": "Inizia Partita",
    "playersOnline": "giocatori online",
    "gamesInProgress": "partite in corso",
    "landing": {
      "heroTitle": "Gioca a Dama",
      "heroTitleAccent": "Online",
      "heroTagline": "Varianti di dama da tutto il mondo. Tornei, partite valutate, avversari IA — gioca ora.",
      "playFree": "Gioca Ora",
      "signUp": "Iscriviti",
      "playAsGuest": "Gioca come Ospite",
      "featuresLabel": "Perché Dama?",
      "featuresTitle": "Tutto ciò che serve per giocare",
      "featuresSubtitle": "Una piattaforma completa per giocatori competitivi e casual.",
      "featureTournaments": "Tornei",
      "featureTournamentsDesc": "Formati Swiss e Arena con accoppiamento automatico, rating Glicko-2 e classifiche in tempo reale.",
      "featureRating": "Sistema di Rating",
      "featureRatingDesc": "Rating Glicko-2 separati per varianti e controlli di tempo. Segui i tuoi progressi.",
      "featureAI": "Avversari IA",
      "featureAIDesc": "6 livelli di difficoltà dal principiante all'esperto. Allenati in qualsiasi momento.",
      "featureVariants": "Varianti dal Mondo",
      "featureVariantsDesc": "Dall'Internazionale e Italiana alla Turca, Frisone e molte altre — varianti di dama da tutto il mondo.",
      "featureOnline": "Gioco online",
      "featureOnlineDesc": "Trova un avversario in pochi secondi con il matchmaking e gioca partite valutate o amichevoli.",
      "featurePuzzles": "Problemi giornalieri",
      "featurePuzzlesDesc": "Un nuovo problema ogni giorno su più varianti. Affina la tattica e fai crescere il tuo rating.",
      "specBoard": "Damiera {{size}}",
      "specPieces": "{{count}} pedine per parte",
      "specFlyingKings": "Dame volanti",
      "specShortKings": "Dame corte",
      "howLabel": "Come?",
      "howTitle": "Inizia a giocare in pochi secondi",
      "step1Title": "Crea un Account",
      "step1Desc": "Registrati in pochi secondi. Oppure gioca subito come ospite.",
      "step2Title": "Scegli il Tuo Gioco",
      "step2Desc": "Scegli variante, controllo tempo e gioca contro persone o IA.",
      "step3Title": "Scala la Classifica",
      "step3Desc": "Vinci partite, guadagna punti rating e partecipa ai tornei giornalieri.",
      "variantsLabel": "Varianti di Gioco",
      "variantsTitle": "Ogni variante della dama, una piattaforma",
      "variantsMoreTitle": "E molte altre varianti",
      "variantsAllCta": "Vedi le regole di ogni variante",
      "intlBadge": "FMJD Ufficiale",
      "intlDesc": "Lo standard per la dama competitiva nel mondo. Dame volanti, cattura obbligatoria e regola della cattura più lunga.",
      "italianBadge": "Tradizionale",
      "italianDesc": "L'amata tradizione italiana. Le pedine non possono catturare le dame e la regola del maggior numero di pezzi catturati crea un gioco tatticamente profondo.",
      "englishBadge": "WCDF Ufficiale",
      "englishDesc": "Dama classica 8×8 giocata in tutto il mondo. Cattura obbligatoria, dame non volanti, pedine che possono catturare dame e nessun movimento all'indietro per le pedine.",
      "brazilianBadge": "Popolare",
      "brazilianDesc": "La variante preferita del Brasile. Tavola 8×8 con dame volanti, cattura più lunga obbligatoria e pedine che catturano all'indietro.",
      "ctaTitle": "Pronto a giocare?",
      "ctaSubtitle": "Unisciti alla community. Inizia la tua prima partita.",
      "ctaButton": "Inizia a Giocare Ora",
      "heroCta": "Gioca subito",
      "puzzleTitle": "Prova un puzzle",
      "puzzleSubtitle": "Risolvi subito questa posizione, senza registrarti. Poi crea un account gratuito per giocare il puzzle del giorno e far crescere il tuo rating."
    },
    "dashboard": {
      "welcomeBack": "Bentornato",
      "recentGames": "Partite Recenti",
      "viewAll": "Vedi Tutto",
      "liveUpcoming": "Live e In Arrivo",
      "allTournaments": "Tutti i Tornei",
      "thisWeek": "questa settimana",
      "live": "LIVE",
      "join": "Partecipa",
      "noRecentGames": "Nessuna partita ancora. Gioca la tua prima!",
      "noTournaments": "Nessun torneo in arrivo.",
      "dailyPuzzle": {
        "title": "Puzzle del giorno",
        "whiteToMove": "Tocca al bianco",
        "blackToMove": "Tocca al nero"
      },
      "timeAgo": {
        "now": "adesso",
        "minutes": "{{count}} min fa",
        "hours": "{{count}}h fa",
        "yesterday": "Ieri",
        "days": "{{count}}g fa",
        "weeks": "{{count}}sett fa",
        "months": "{{count}}m fa"
      }
    }
  },
  "game": {
    "header": {
      "rated": "Valutata",
      "casual": "Amichevole",
      "variantRules": "Regole della variante"
    },
    "variants": {
      "international": "Dama Internazionale 10×10",
      "internationalShort": "Internazionale 10×10",
      "internationalMedium": "Internazionale 10×10",
      "italian": "Dama Italiana 8×8",
      "italianShort": "Italiana 8×8",
      "english": "Dama Inglese 8×8",
      "englishShort": "Inglese 8×8",
      "englishBadge": "WCDF Ufficiale",
      "englishDesc": "Dama classica 8×8 giocata in tutto il mondo. Cattura obbligatoria, dame non volanti, pedine che possono catturare dame e nessun movimento all'indietro per le pedine.",
      "brazilian": "Dama Brasiliana 8×8",
      "brazilianShort": "Brasiliana 8×8",
      "frisian": "Dama Frisone 10×10",
      "frisianShort": "Frisone 10×10",
      "frysk": "Frysk! 10×10",
      "fryskShort": "Frysk 10×10",
      "turkish": "Dama Turca 8×8",
      "turkishShort": "Turca 8×8",
      "armenian": "Tama Armena 8×8",
      "armenianShort": "Armena 8×8",
      "russian": "Dama Russa 8×8",
      "russianShort": "Russa 8×8",
      "spanish": "Dama Spagnola 8×8",
      "spanishShort": "Spagnola 8×8",
      "triestine": "Dama Triestina 10×10",
      "triestineShort": "Triestina 10×10",
      "canadian": "Dama Canadese 12×12",
      "canadianShort": "Canadese 12×12",
      "nigerian": "Dama Nigeriana 10×10",
      "nigerianShort": "Nigeriana 10×10",
      "ghanaian": "Dama Ghanese 10×10",
      "ghanaianShort": "Ghanese 10×10",
      "pool": "Pool Checkers 8×8",
      "poolShort": "Pool 8×8",
      "czech": "Dama Ceca 8×8",
      "czechShort": "Ceca 8×8",
      "thai": "Makhos Thai 8×8",
      "thaiShort": "Thai 8×8",
      "portuguese": "Dama Portoghese 8×8",
      "portugueseShort": "Portoghese 8×8",
      "filipino": "Dama Filippina 8×8",
      "filipinoShort": "Filippina 8×8",
      "malaysian": "Dama Malese 12×12",
      "malaysianShort": "Malese 12×12",
      "german": "Damenspiel Tedesco 8×8",
      "germanShort": "Tedesca 8×8",
      "jamaican": "Dama Giamaicana 8×8",
      "jamaicanShort": "Giamaicana 8×8",
      "sinhalese": "Dama Singalese 8×8",
      "sinhaleseShort": "Singalese 8×8",
      "south_african": "Dama Sudafricana 14×14",
      "south_africanShort": "Sudafricana 14×14",
      "dameo": "Dameo 8×8",
      "dameoShort": "Dameo 8×8",
      "croda": "Croda 8×8",
      "crodaShort": "Croda 8×8"
    },
    "opponent": {
      "computer": "AI"
    },
    "modes": {
      "twoPlayers": "2 Giocatori",
      "aiVeryEasy": "Molto Facile",
      "aiEasy": "Facile",
      "aiMedium": "Medio",
      "aiHard": "Difficile",
      "aiExpert": "Molto Difficile",
      "aiMaster": "Esperto",
      "playOnline": "Gioca Online"
    },
    "timeControls": {
      "noTimeLimit": "Senza Limite di Tempo",
      "blitz30": "Blitz 3+0",
      "blitz32": "Blitz 3+2",
      "blitz50": "Blitz 5+0",
      "blitz53": "Blitz 5+3",
      "rapid105": "Rapid 10+5",
      "rapid1510": "Rapid 15+10"
    },
    "turn": {
      "yourTurn": "Tocca a te",
      "opponentTurn": "Turno dell'avversario",
      "toMove": "Muove",
      "aiThinking": "L'IA sta pensando...",
      "aiTurn": "Turno IA",
      "aiDeclinedDraw": "Il computer ha rifiutato la patta",
      "whiteToMove": "Muove il bianco",
      "blackToMove": "Muove il nero"
    },
    "result": {
      "youWin": "Hai Vinto!",
      "youLose": "Hai Perso!",
      "draw": "Patta!",
      "whiteWins": "Il Bianco Vince!",
      "blackWins": "Il Nero Vince!",
      "gameOver": "Partita Terminata",
      "gameAbandoned": "Partita Abbandonata",
      "noWinner": "Partita interrotta",
      "won": "Vinta",
      "lost": "Persa"
    },
    "drawCountdown": {
      "aria_one": "Patta automatica fra {{count}} mossa se muovono solo le dame",
      "aria_other": "Patta automatica fra {{count}} mosse se muovono solo le dame"
    },
    "frisianCountdown": {
      "aria_one": "Patta automatica fra {{count}} mossa: due dame contro una",
      "aria_other": "Patta automatica fra {{count}} mosse: due dame contro una"
    },
    "endReason": {
      "checkmate": "senza mosse",
      "noLegalMoves": "non ha più mosse legali.",
      "whiteNoMoves": "Il bianco non ha più mosse legali.",
      "blackNoMoves": "Il nero non ha più mosse legali.",
      "drawEnded": "La partita è terminata in patta.",
      "gameAbandoned": "La partita è stata abbandonata.",
      "noWinner": "La partita è finita senza vincitore.",
      "gameEnded": "La partita è terminata.",
      "resignation": "abbandono",
      "disconnection": "disconnessione",
      "fiftyMoves": "50 mosse",
      "timeout": "tempo scaduto",
      "agreement": "patta per accordo",
      "walkover": "vittoria a tavolino",
      "firstKing": "Prima dama",
      "sideResigned": "{{side}} ha abbandonato.",
      "sideTimeout": "Tempo scaduto per {{side}}.",
      "sideNoPieces": "{{side}} non ha più pezzi.",
      "moveLimit": "Troppe mosse senza catture.",
      "repetition": "Stessa posizione ripetuta tre volte.",
      "endgameDraw": "Finale di patta teorica.",
      "sideZugzwang": "{{side}} è in zugzwang: ogni mossa perde.",
      "loneKing": "La dama sola batte la pedina sola.",
      "sideSinglePiece": "{{side}} è rimasto con un solo pezzo.",
      "drawAgreed": "Patta per accordo.",
      "sideNoFirstMove": "{{side}} non ha mosso in tempo.",
      "noFirstMove": "Prima mossa non giocata in tempo."
    },
    "actions": {
      "newGame": "Nuova Partita",
      "resign": "Abbandona",
      "endGame": "Termina",
      "leaveGame": "Esci dalla Partita",
      "backToLobby": "Torna alla Lobby",
      "offerDraw": "Patta",
      "drawOffered": "L'avversario propone la patta",
      "drawSent": "Patta proposta…",
      "acceptDraw": "Accetta",
      "declineDraw": "Rifiuta",
      "drawDeclined": "L'avversario ha rifiutato la patta",
      "drawMoveFirst": "Muovi prima",
      "drawMustMoveFirst": "Gioca una mossa prima di riproporre la patta.",
      "drawNoneLeft": "Proposte esaurite",
      "drawLimitReached": "Hai usato tutte le proposte di patta di questa partita.",
      "drawTooFast": "Troppe proposte di patta. Aspetta un momento.",
      "requestTakeback": "Rifai mossa",
      "takebackRequested": "Richiesta di rifare la mossa inviata…",
      "opponentRequestsTakeback_one": "L'avversario chiede di rifare {{count}} mossa",
      "opponentRequestsTakeback_other": "L'avversario chiede di rifare le ultime {{count}} mosse",
      "acceptTakeback": "Accetta",
      "declineTakeback": "Rifiuta",
      "takebackDeclined": "La tua richiesta di rifare la mossa è stata rifiutata",
      "takebackAccepted": "La tua richiesta di rifare la mossa è stata accettata",
      "takebackDisabledRated": "Il rifai mossa è disattivato nelle partite valutate",
      "focus": "Focus",
      "focusExit": "Esci",
      "peek": "Sbircia",
      "boardSize": "Dimensione damiera",
      "boardBigger": "Damiera più grande",
      "boardSmaller": "Damiera più piccola",
      "flipBoard": "Gira"
    },
    "confirmLeave": "Sei sicuro di voler abbandonare la partita?",
    "confirmLeaveTitle": "Abbandonare la partita?",
    "confirmLeaveCancel": "Annulla",
    "confirmLeaveButton": "Abbandona",
    "confirmResignTitle": "Abbandonare?",
    "confirmResign": "Sei sicuro di volerti arrendere? Perderai la partita.",
    "confirmEndGameTitle": "Terminare la partita?",
    "confirmEndGame": "La partita si chiuderà senza vincitore.",
    "clock": {
      "white": "Bianco",
      "black": "Nero"
    },
    "aborted": {
      "opponentLeft": "L'avversario è uscito prima dell'inizio — cerco un nuovo avversario…",
      "opponentDidNotMove": "L'avversario non ha mosso in tempo — partita annullata."
    },
    "disconnection": {
      "opponentDisconnected": "Avversario Disconnesso",
      "waitingToReconnect": "In attesa che l'avversario si riconnetta...",
      "opponentLeft": "L'avversario ha lasciato la partita",
      "disconnected": "Disconnesso",
      "notPresent": "Non presente",
      "avvisoMaiArrivato": "Avversario non ancora presente: se non arriva, vinci allo scadere del suo orologio.",
      "avvisoDecideOrologio": "Avversario disconnesso: se non rientra, vinci allo scadere del suo orologio.",
      "avvisoGrazia": "Avversario disconnesso: se non rientra entro {{secondi}} s, vinci.",
      "avvisoMaiArrivatoTuoTurno": "Avversario non ancora presente: muovi tu, poi se non arriva vinci allo scadere del suo orologio.",
      "avvisoDecideOrologioTuoTurno": "Avversario disconnesso: muovi tu, poi se non rientra vinci allo scadere del suo orologio."
    },
    "sidebar": {
      "moves": "Mosse",
      "openingNumbered": "Apertura N° {{n}}",
      "openingDrawn": "Apertura sorteggiata",
      "chat": "Chat",
      "spectators": "Spettatori",
      "noMoves": "Nessuna mossa",
      "viewMove": "Vedi posizione dopo la mossa {{n}}",
      "goToStart": "Vai all'inizio",
      "prevMove": "Mossa precedente",
      "nextMove": "Mossa successiva",
      "goLive": "Vai alla posizione attuale",
      "play": "Riproduci",
      "pause": "Pausa",
      "position": "Posizione nella linea",
      "showMoves": "Mostra le mosse",
      "hideMoves": "Nascondi le mosse"
    },
    "blind": {
      "lastMove": "Ultima mossa",
      "promoted": "Dama",
      "noPeeks": "Partita giocata senza mai sbirciare.",
      "peeks_one": "Hai sbirciato {{count}} volta.",
      "peeks_other": "Hai sbirciato {{count}} volte."
    },
    "confirmDrawTitle": "Patta?",
    "confirmDraw": "Chiudere la partita in parità? I due giocatori devono essere d’accordo.",
    "match": {
      "playReturn": "Gioca il ritorno"
    },
    "primaMossa": {
      "secondi_one": "{{count}}s",
      "secondi_other": "{{count}}s",
      "ariaVoid_one": "Prima mossa entro {{count}} secondo, o la partita viene annullata",
      "ariaVoid_other": "Prima mossa entro {{count}} secondi, o la partita viene annullata",
      "ariaForfeit_one": "Prima mossa entro {{count}} secondo, o si perde a tavolino",
      "ariaForfeit_other": "Prima mossa entro {{count}} secondi, o si perde a tavolino"
    },
    "saluto": {
      "invia": "Augura buon gioco all'avversario",
      "mittente": "{{username}}:",
      "ancheATe": "Anche a te",
      "inviato": "Saluto inviato"
    }
  },
  "online": {
    "title": "Gioco Online",
    "playOnline": "Gioca Online",
    "connecting": "Connessione al server...",
    "connectionFailed": "Connessione Fallita",
    "couldNotConnect": "Impossibile connettersi al server di gioco.",
    "error": "Errore",
    "room": {
      "title": "Stanza",
      "code": "Codice stanza",
      "shareCode": "Condividi questo codice stanza:",
      "playAs": "Giochi come",
      "waitingForOpponent": "In Attesa dell'Avversario"
    },
    "lobby": {
      "findMatch": "Trova Partita",
      "matchmakingByRating": "Matchmaking automatico per rating",
      "signInToMatch": "Accedi per usare il matchmaking automatico con rating",
      "createGame": "Crea una Partita",
      "selectVariantAndTime": "Seleziona variante e controllo tempo",
      "createRoom": "Crea Stanza",
      "joinGame": "Unisciti a una Partita",
      "enterRoomCode": "Inserisci un codice stanza per unirti",
      "join": "Unisciti",
      "playWithFriends": "o gioca con amici"
    },
    "matchmaking": {
      "findingOpponent": "Ricerca Avversario...",
      "matchingSimilarSkill": "Stiamo cercando un giocatore di abilità simile...",
      "creatingRoom": "Creazione stanza...",
      "joiningRoom": "Ingresso nella stanza...",
      "estimatedWait": "Attesa stimata: ~{{seconds}}s",
      "timeout": "Nessun avversario trovato. Riprova."
    },
    "errors": {
      "authRequired": "Devi accedere per giocare online.",
      "alreadyInQueue": "Stai già cercando una partita.",
      "alreadyInGame": "Sei già in una partita.",
      "generico": "Qualcosa non ha funzionato. Riprova.",
      "nonConnesso": "Non sei connesso al server.",
      "partitaSparita": "Questa partita non esiste più.",
      "drawOfferFailed": "Non è stato possibile proporre la patta.",
      "serverRestart": "Il server si sta riavviando: la partita riprende fra poco. Se non torna, ricarica la pagina.",
      "sfidaTroppeRichieste": "Hai mandato troppe sfide di fila. Aspetta un momento.",
      "avversarioOffline": "Questo giocatore si è scollegato.",
      "avversarioInPartita": "Questo giocatore sta già giocando. Riprova quando ha finito.",
      "seiInGara": "Sei iscritto a un torneo o a un’arena in corso: finisci quello prima.",
      "avversarioInGara": "Questo giocatore sta giocando un torneo o un’arena.",
      "troppePosizioni": "Troppe posizioni personalizzate di fila. Aspetta un momento.",
      "impostazioniNonValide": "Queste impostazioni non vanno bene. Controllale e riprova.",
      "soloIscritti": "Questo giocatore può giocare solo partite amichevoli.",
      "avversarioNonDisturbare": "Questo giocatore non sta accettando sfide. Riprova più tardi.",
      "sfidaGiaInVolo": "Hai già una sfida in attesa di risposta. Annullala prima.",
      "sfidaGiaMandata": "Hai già sfidato questo giocatore: aspetta che risponda."
    },
    "challenge": {
      "challenge": "Sfida",
      "sendChallenge": "Sfida diretta",
      "incomingChallenge": "Sfida in Arrivo",
      "tabBadge": "Sfida!",
      "send": "Invia",
      "accept": "Accetta",
      "decline": "Rifiuta",
      "cancel": "Annulla",
      "loginRequired": "Accedi per vedere i giocatori online e inviare sfide",
      "waitingForResponse": "In attesa di {{username}}...",
      "declined": "Sfida rifiutata",
      "expired": "Sfida scaduta",
      "cancelled": "Sfida annullata",
      "color": "Colore",
      "gameType": "Tipo partita",
      "colorRandom": "Casuale",
      "rated": "Valutata (senza ospiti)",
      "casual": "Amichevole",
      "gameTypeAny": "Valutata/Amichevole",
      "registeredOnly": "Solo iscritti",
      "registeredOnlyNote": "Solo i giocatori iscritti possono giocare questa partita.",
      "opponentGuestNoRated": "Questo avversario è un ospite: la partita non può essere valutata.",
      "mode": "Modalità",
      "modeNormal": "Standard",
      "modeBreakthrough": "Breakthrough",
      "modeAntidraughts": "Antidraughts",
      "modeBlind": "Alla cieca",
      "modeInfoLabel": "Informazioni sulle modalità",
      "modeBreakthroughInfo": "Vince subito il primo che promuove una pedina a dama.",
      "modeAntidraughtsInfo": "Obiettivo invertito: vince chi resta senza pezzi, o senza mosse legali.",
      "modeBlindInfo": "I pezzi sono invisibili: si gioca a memoria, come da bendati. Le regole restano quelle normali.",
      "opening": "Apertura",
      "legs": "Partite",
      "legsOne": "Solo andata",
      "legsTwo": "Andata e ritorno",
      "openingDrawnSingleLegCasual": "Con questa apertura una sola partita non compensa il vantaggio del sorteggio: la partita è sempre amichevole.",
      "time": "Tempo",
      "increment": "Incremento",
      "noClockCasual": "Le partite senza limite di tempo sono sempre amichevoli.",
      "link": {
        "inviteFriend": "Invita un amico",
        "title": "Sfida un amico",
        "intro": "Manda questo link a chi vuoi: chi lo apre per primo gioca con te, anche senza account.",
        "share": "Condividi",
        "copy": "Copia link",
        "copied": "Copiato!",
        "copyFailed": "Impossibile copiare il link. Selezionalo e copialo a mano.",
        "expiresIn": "Il link è valido ancora {{time}}.",
        "startingSoon": "La partita sta per iniziare...",
        "friendAccepted": "{{name}} ha accettato la sfida!",
        "cancelLink": "Annulla la sfida",
        "shareTitle": "Sfida a dama",
        "shareText": "Ti sfido a dama!",
        "shareTextWith": "Ti sfido a dama — {{summary}}",
        "challengesYou": "{{name}} ti sfida a dama",
        "playNow": "Gioca subito",
        "haveAccount": "Ho già un account",
        "guestCasualNote": "Se giochi come ospite la partita sarà amichevole (non conta per il punteggio).",
        "waitingChallengerTitle": "Sfida accettata",
        "waitingChallenger": "In attesa che {{name}} torni online. La partita inizierà da sola.",
        "unavailableTitle": "Sfida non disponibile",
        "cancelledByChallenger": "Chi ti ha sfidato ha annullato la partita.",
        "expiredOrGone": "Questo link è scaduto o non è più valido. Chiedine uno nuovo al tuo amico.",
        "backHome": "Torna alla home"
      },
      "opening_free": "Mossa libera",
      "opening_random1": "1 mossa a caso qualsiasi",
      "opening_random2": "2 mosse a caso qualsiasi",
      "opening_random3": "3 mosse a caso qualsiasi",
      "opening_ballot1": "Tabella C - 1N/1B",
      "opening_ballot2": "Tabella B - 2N/2B",
      "opening_ballot3": "Tabella {{tables}} - 3N/3B",
      "opening_ballot4": "Tabella generale",
      "opening_single": "Apertura fissa",
      "openingInfoLabel": "Informazioni sulle aperture",
      "openingInfo": "Le voci “Tabella” pescano dalle tabelle ufficiali F.I.D.: il numero fra parentesi dice da quante aperture pesca il sorteggio, e la soglia (1N/1B … 4N/4B) limita quanto può essere squilibrata. Fino alla Tabella B una sola partita resta valutata; oltre serve andata e ritorno. Le voci “a caso qualsiasi” sorteggiano invece fra tutte le mosse legali, senza nessun limite di squilibrio: da 2 mosse in su servono andata e ritorno.",
      "openingInfoRandom": "Le prime semi-mosse vengono sorteggiate fra tutte quelle legali: il numero fra parentesi dice quante combinazioni diverse possono uscire. Questa variante non ha tabelle ufficiali di apertura. Da 2 mosse in su il sorteggio può favorire un colore, quindi la partita conta per il rating solo in andata e ritorno.",
      "openingTablesLink": "Vedi le tabelle di apertura",
      "guestCannotChallenge": "La sfida diretta è riservata agli utenti registrati. Accedi o registrati gratuitamente per inviare sfide dirette.",
      "guestCasualInvite": "Accedi o registrati gratuitamente per giocare partite valutate.",
      "changeOpponent": "Cambia",
      "challengePlayer": "Sfida {{username}}",
      "tableOpen": {
        "title": "{{username}} ha già un tavolo aperto",
        "other": "Invia una sfida diversa"
      }
    },
    "status": {
      "playing": "Gioca",
      "playingWith": "Gioca vs {{username}}",
      "waiting": "Aspetta",
      "away": "Assente",
      "busy": "Occupato"
    },
    "chooseOpponent": "Scegli chi sfidare",
    "ratingsBucket": "Punteggi:",
    "onlinePlayers": "Giocatori online",
    "loadingPlayers": "Caricamento giocatori...",
    "noPlayersOnline": "Al momento non c’è nessun altro online",
    "reloadIn": "Ricarica tra {{seconds}} s",
    "reloadInShort": "{{seconds}} s",
    "rematch": {
      "rematch": "Rivincita",
      "accept": "Accetta",
      "decline": "Rifiuta",
      "sessionScore": "Punteggio",
      "opponentWantsRematch": "L'avversario vuole la rivincita!",
      "declined": "L'avversario ha rifiutato la rivincita",
      "expired": "L'offerta di rivincita è scaduta",
      "invite": {
        "incoming": "Invito alla rivincita",
        "tabBadge": "Rivincita!",
        "message": "<b>{{name}}</b> ({{rating}}) vuole la rivincita · <b>{{timeControl}}</b> · {{variant}}",
        "messageNoRating": "<b>{{name}}</b> vuole la rivincita · <b>{{timeControl}}</b> · {{variant}}"
      },
      "waitingForOpponent": "In attesa dell'avversario...",
      "newOpponent": "Torna alla Home"
    },
    "match": {
      "legFirst": "Andata",
      "legSecond": "Ritorno",
      "legOf": "Partita {{leg}} di {{total}}",
      "legShort": "{{leg}}/{{total}}",
      "score": "Match",
      "returnStartsIn": "Il ritorno inizia tra {{seconds}}s",
      "leavingForfeits": "Se esci ora perdi il ritorno a tavolino.",
      "ratingAtMatchEnd": "Il rating viene aggiornato a fine match.",
      "ready": "Pronto",
      "opponentReady": "L'avversario è pronto",
      "waitingOpponent": "In attesa dell'avversario...",
      "complete": "Match concluso",
      "newMatch": "Nuovo match",
      "twoLegsShort": "A/R"
    },
    "connectedCount": "{{count}} Online",
    "viewProfile": "Profilo",
    "connessionePersa": {
      "titolo": "Connessione persa",
      "corpo": "Sto provando a riportarti al tavolo.",
      "riprova": "Riprova",
      "esci": "Esci"
    },
    "partitaFinitaMentreEriVia": "La partita è finita mentre eri via.",
    "sessioneAltrove": {
      "titolo": "Aperto su un altro dispositivo",
      "corpo": "Hai aperto il gioco altrove: qui non ricevi più mosse e sfide.",
      "usaQui": "Usa qui"
    }
  },
  "lobby": {
    "title": "Gioca",
    "quickPlay": "Accoppiamento rapido",
    "customGame": "Partita personalizzata",
    "opponent": "Avversario",
    "opponentOnline": "Online (casuale)",
    "opponentInPerson": "In presenza",
    "startInPerson": "Inizia la partita",
    "inPersonNote": "Due giocatori sullo stesso dispositivo. Non conta per il punteggio.",
    "openTable": "Apri il tavolo",
    "openTables": "Tavoli in attesa",
    "noTablesInVariant": "Nessun tavolo in {{variant}} al momento. Premi una cadenza per aprire il tuo.",
    "noTablesInVariantOrOther": "Nessun tavolo in {{variant}} al momento. Premi una cadenza per aprire il tuo, oppure siediti a uno di un'altra variante:",
    "otherVariants": "Altre varianti",
    "sit": "Siediti",
    "cancelTable": "Annulla",
    "waitingAtTable": "In attesa di un avversario",
    "inQueue": "Sei in coda",
    "tableExpired": "Il tuo tavolo è scaduto dopo 10 minuti senza avversario. Riaprilo quando vuoi.",
    "customPosition": "Posizione personalizzata",
    "errors": {
      "inCompetition": "Esci prima dall’arena o dal torneo.",
      "rateLimited": "Troppi tavoli. Aspetta un momento.",
      "tableGone": "Quel tavolo non è più disponibile.",
      "hostGone": "Chi aveva aperto il tavolo non c'è più.",
      "ownTable": "Questo è il tuo tavolo.",
      "invalidSettings": "Queste impostazioni non sono valide.",
      "startFailed": "Non è stato possibile avviare la partita. Riprova.",
      "generic": "Qualcosa è andato storto. Riprova."
    }
  },
  "spectate": {
    "watch": "Guarda",
    "watchPlayer": "Guarda la partita di {{username}}",
    "watchPair": "Guarda {{a}} contro {{b}}",
    "watching": "Stai guardando",
    "leave": "Esci",
    "loading": "Caricamento partita...",
    "turnWhite": "Muove il Bianco",
    "turnBlack": "Muove il Nero",
    "whiteWins": "Vince il Bianco",
    "blackWins": "Vince il Nero",
    "draw": "Patta",
    "gameOver": "Partita finita",
    "betweenLegs": "Finita l'andata: tra poco il ritorno",
    "unavailable": "Questa partita non è più disponibile",
    "error": {
      "notPlaying": "Questo giocatore non è più in partita.",
      "unavailable": "Questa partita non è più disponibile.",
      "busy": "Non puoi guardare una partita mentre stai giocando.",
      "self": "Questa è la tua partita: aprila dalla tua damiera."
    },
    "watchers": {
      "empty": "Adesso non guarda nessuno."
    }
  },
  "auth": {
    "signIn": "Accedi",
    "signUp": "Registrati",
    "preferredVariantHint": "Puoi cambiarla in qualsiasi momento",
    "createAccount": "Crea Account",
    "noAccount": "Non hai un account?",
    "hasAccount": "Hai già un account?",
    "fields": {
      "username": "Nome utente",
      "email": "Email",
      "password": "Password",
      "confirmPassword": "Conferma Password",
      "emailOrUsername": "Email o Nome utente"
    },
    "placeholders": {
      "chooseUsername": "Scegli un nome utente",
      "yourEmail": "tua@email.it",
      "atLeast8Chars": "Almeno 8 caratteri",
      "confirmYourPassword": "Conferma la tua password",
      "enterEmailOrUsername": "Inserisci email o nome utente",
      "yourPassword": "La tua password"
    },
    "errors": {
      "passwordsNoMatch": "Le password non corrispondono",
      "passwordTooShort": "La password deve essere di almeno 8 caratteri",
      "usernameTooShort": "Il nome utente deve essere di almeno 3 caratteri",
      "passwordRequirements": "La password deve contenere almeno una lettera maiuscola, una minuscola e un numero",
      "network": "Nessuna connessione a internet. Controlla la connessione e riprova.",
      "guestLoginFailed": "Non è stato possibile entrare come ospite. Controlla la connessione e riprova.",
      "guestLoginRateLimited": "Troppi accessi come ospite da questa rete. Riprova fra qualche minuto, oppure accedi con il tuo account."
    },
    "validation": {
      "usernameChars": "Solo lettere, numeri e underscore",
      "invalidEmail": "Inserisci un indirizzo email valido",
      "min8": "8+ caratteri",
      "uppercase": "maiuscola",
      "lowercase": "minuscola",
      "number": "numero"
    },
    "playAsGuest": "Gioca come ospite",
    "guestBanner": "Stai giocando come ospite.",
    "guestBannerCta": "Registrati per salvare i tuoi progressi.",
    "guestUpgrade": "Crea Account",
    "guestRestriction": "Questa funzione richiede un account registrato",
    "guestCannotTournament": "Registrati per partecipare ai tornei",
    "guestCannotChallenge": "Registrati per sfidare i giocatori",
    "forgotPassword": "Password dimenticata?",
    "forgotPasswordDesc": "Inserisci la tua email e ti invieremo un link per reimpostare la password.",
    "sendResetLink": "Invia link di reset",
    "resetEmailSent": "Controlla la tua email",
    "checkSpam": "Non lo trovi? Controlla la cartella spam.",
    "backToLogin": "Torna al login",
    "resetPassword": "Reimposta password",
    "resetPasswordDesc": "Inserisci la tua nuova password qui sotto.",
    "newPassword": "Nuova password",
    "confirmPassword": "Conferma password",
    "resetSuccess": "Password aggiornata con successo. Ora puoi accedere.",
    "resetExpired": "Questo link di reset è scaduto. Richiedine uno nuovo.",
    "resetInvalid": "Link di reset non valido o scaduto.",
    "verifyEmail": {
      "title": "Controlla la tua email",
      "checkInbox": "Abbiamo inviato un link di verifica a {{email}}. Clicca il link per attivare il tuo account.",
      "spamHint": "Non lo trovi? Controlla la cartella spam.",
      "pageTitle": "Verifica Email",
      "verifying": "Verifica dell'email in corso...",
      "success": "Email verificata. Il tuo account è attivo.",
      "successAndBack": "Email verificata. Ti riportiamo al torneo.",
      "verifyButton": "Verifica la mia email",
      "error": "Verifica fallita. Riprova.",
      "loginBlocked": "Verifica la tua email prima di accedere",
      "resendLink": "Reinvia email di verifica",
      "resendSent": "Email di verifica inviata!",
      "enterEmailToResend": "Accedi con il tuo indirizzo email per reinviare la verifica",
      "wrongAddress": "Indirizzo sbagliato?",
      "changeAddress": "Correggi l'indirizzo",
      "newAddressLabel": "Nuovo indirizzo email",
      "passwordLabel": "La password che hai appena scelto",
      "changeSubmit": "Invia al nuovo indirizzo",
      "changeSent": "Se l'account esiste ed è in attesa di verifica, abbiamo mandato il link al nuovo indirizzo.",
      "changeFailed": "Non è stato possibile cambiare l'indirizzo. Riprova fra qualche minuto."
    }
  },
  "profile": {
    "title": "Profilo",
    "notFound": "Profilo Non Trovato",
    "userNotFound": "Utente non trovato",
    "memberSince": "Membro dal {{date}}",
    "goBack": "Torna Indietro",
    "loadingProfile": "Caricamento profilo...",
    "tabs": {
      "overview": "Panoramica",
      "games": "Partite",
      "stats": "Statistiche"
    },
    "variants": {
      "all": "Tutte"
    },
    "stats": {
      "rating": "Rating",
      "games": "Partite",
      "wins": "Vittorie",
      "losses": "Sconfitte",
      "draws": "Patte",
      "winRate": "Percentuale Vittorie",
      "winRateShort": "Vittorie",
      "winLossBreakdown": "Vittorie · Patte · Sconfitte",
      "peakRating": "Rating max",
      "streak": "Serie",
      "bestStreak": "Migliore",
      "avgTime": "Tempo Medio",
      "title": "Statistiche Dettagliate",
      "comingSoon": "Prossimamente...",
      "loading": "Caricamento statistiche...",
      "noData": "Nessuna partita ancora. Gioca qualche partita per vedere le tue statistiche!",
      "byTimeControl": "Performance per Controllo Tempo",
      "byColor": "Performance per Colore",
      "general": "Generale",
      "asWhite": "Con il Bianco",
      "asBlack": "Con il Nero",
      "totalGames": "Partite Totali",
      "avgMoves": "Media Mosse",
      "gamesShort": "partite",
      "mostActive": "Giocatori più attivi",
      "mostActiveEmpty": "Nessuna partita in questa variante.",
      "viewFullLeaderboard": "Vedi la classifica completa",
      "ratingEvolution": "Evoluzione rating · ultimi 30 giorni",
      "chartComingSoon": "Storico in arrivo",
      "peakShort": "Max",
      "barraEsito": "{{win}}% vittorie, {{draw}}% patte, {{loss}}% sconfitte",
      "percentualeVittorie": "{{rate}}% di vittorie",
      "siglaVittorie": "V",
      "siglaPatte": "P",
      "siglaSconfitte": "S"
    },
    "games": {
      "today": "Oggi",
      "yesterday": "Ieri",
      "daysAgo": "{{days}} giorni fa",
      "weeksAgo": "{{weeks}} sett. fa",
      "moves": "mosse",
      "sourceArena": "Arena",
      "sourceTournament": "Torneo",
      "loading": "Caricamento partite...",
      "noGames": "Nessuna partita trovata",
      "clearFilters": "Rimuovi filtri",
      "clearFiltersActive": "Rimuovi filtri attivi",
      "loadMore": "Carica Altre",
      "showing": "{{count}} partite",
      "clickViewAll": "Clicca \"Vedi tutte\" per lo storico partite",
      "filterResult": "Risultato",
      "filterTimeControl": "Cadenza",
      "filterVariant": "Variante",
      "filterOpponent": "Avversario",
      "filters": {
        "all": "Tutte",
        "wins": "Vittorie",
        "draws": "Patte",
        "losses": "Sconfitte",
        "allVariants": "Tutte le Varianti",
        "allTimeControls": "Tutti i Tempi",
        "vsMe": "Contro di me"
      }
    },
    "challenge": "Sfida",
    "settings": "Impostazioni",
    "gameSettings": "Impostazioni gioco",
    "preferredVariant": "Variante preferita",
    "preferredCadence": "Cadenza preferita",
    "accountSettings": "Account",
    "audioHaptics": "Suono e Vibrazione",
    "changePassword": "Cambia password",
    "changePasswordSub": "Aggiorna la tua password",
    "currentPassword": "Password attuale",
    "newPassword": "Nuova password",
    "passwordChanged": "Password cambiata con successo",
    "analyticsLabel": "Cookie analitici",
    "language": "Lingua",
    "country": "Paese",
    "countryNone": "Non impostato",
    "logout": "Esci",
    "logoutSub": "Esci dal tuo account",
    "exportData": "Esporta i miei dati",
    "exportDataSub": "Scarica un JSON dei tuoi dati",
    "deleteAccount": {
      "button": "Elimina account",
      "sub": "Cancella permanentemente il tuo account",
      "title": "Elimina Account",
      "warning": "Questa azione è permanente e non può essere annullata. Tutti i tuoi dati verranno eliminati.",
      "confirmPassword": "Inserisci la password per confermare",
      "confirm": "Elimina definitivamente",
      "error": "Impossibile eliminare l'account"
    },
    "graphics": {
      "title": "Grafica",
      "pieceShape": "Forma dei pezzi",
      "pieceStyle": "Stile dei pezzi",
      "kingIcon": "Icona dama",
      "pieceColor": "Colore pedine",
      "pieceColorAutoHint": "I colori delle pedine cambiano con la variante.",
      "pieceMaterial": "Materiale pedine",
      "boardColor": "Colore damiera",
      "boardColorAutoHint": "I colori della damiera cambiano con la variante.",
      "boardMaterial": "Materiale damiera",
      "boardNotation": "Notazione damiera",
      "notation": "Notazione",
      "shapes": {
        "round": "Rotonda",
        "donut": "Ciambella",
        "square": "Quadrata",
        "rhombus": "Rombo",
        "triangle": "Triangolo",
        "star": "Stella",
        "heart": "Cuore"
      },
      "styles": {
        "3d-stacked-engraved": "3D impilato inciso",
        "3d-stacked-smooth": "3D impilato liscio",
        "3d-crown": "3D con corona",
        "flat-plain": "Piatto liscio",
        "flat-engraved": "Piatto inciso"
      },
      "kingIcons": {
        "crown": "Corona",
        "ring": "Anello",
        "star": "Stella",
        "diamond": "Diamante",
        "none": "Nessuna"
      },
      "crownType": "Tipo di corona",
      "crownTypes": {
        "classic": "Classica",
        "plain": "Essenziale",
        "diadem": "Diadema",
        "lily": "Gigliata",
        "imperial": "Imperiale"
      },
      "pieceColors": {
        "auto": "Auto (per variante)",
        "custom": "Personalizzato…",
        "italian": "Italiana",
        "international": "Internazionale",
        "english": "Inglese",
        "brazilian": "Brasiliana",
        "classic": "Classico",
        "white-black": "Bianco/Nero",
        "red-black": "Rosso/Nero",
        "blue-red": "Blu/Rosso",
        "orange-blue": "Arancio/Blu (daltonismo)",
        "silver-gold": "Argento/Oro",
        "coral-teal": "Corallo/Turchese",
        "green-purple": "Verde/Viola",
        "pink-navy": "Rosa/Blu notte"
      },
      "materials": {
        "plastic": "Plastica",
        "marble": "Marmo",
        "glass": "Vetro",
        "wood": "Legno"
      },
      "boards": {
        "auto": "Auto (per variante)",
        "custom": "Personalizzato…",
        "wood-classic": "Internazionale",
        "italian": "Italiana",
        "english": "Inglese",
        "brazilian": "Brasiliana",
        "walnut": "Noce",
        "green-cream": "Verde/Crema",
        "blue-grey": "Blu/Grigio",
        "marble": "Marmo",
        "high-contrast": "Alto contrasto",
        "mahogany": "Mogano",
        "ocean": "Oceano",
        "purple-lavender": "Viola/Lavanda",
        "rose": "Rosa"
      },
      "notations": {
        "none": "Nessuna",
        "numeric": "Numeri",
        "algebraic": "Coordinate"
      },
      "hue": "Tinta",
      "customPieceLight": "Pedine chiare",
      "customPieceDark": "Pedine scure",
      "customBoardLight": "Caselle chiare",
      "customBoardDark": "Caselle scure",
      "picker": {
        "edit": "Modifica colori",
        "hex": "Esadecimale",
        "area": "Saturazione e luminosità",
        "saturation": "Saturazione",
        "brightness": "Luminosità",
        "tooClose": "I due colori sono molto simili: pedine o caselle potrebbero essere difficili da distinguere."
      },
      "uiTheme": "Tema dell’app",
      "themes": {
        "light": "Chiaro",
        "dark": "Scuro"
      }
    },
    "game": {
      "title": "Gioco",
      "moveSound": "Attiva suono mosse",
      "lowTimeSound": "Attiva suono poco tempo",
      "notificationSound": "Attiva suono notifiche",
      "vibration": "Attiva vibrazione per mosse"
    },
    "gameplay": {
      "title": "Gioco",
      "showMoveHints": "Mostra mosse possibili",
      "showLastMove": "Evidenzia ultima mossa",
      "showLastMoveCaptures": "Evidenzia catture",
      "premove": "Abilita le premosse"
    },
    "avatar": {
      "title": "Scegli un avatar",
      "choose": "Avatar disponibili",
      "remove": "Nessun avatar",
      "edit": "Cambia avatar",
      "presets": {
        "crown": "Corona",
        "star": "Stella",
        "flame": "Fiamma",
        "zap": "Fulmine",
        "shield": "Scudo",
        "rocket": "Razzo",
        "gem": "Gemma",
        "leaf": "Foglia",
        "moon": "Luna",
        "sun": "Sole",
        "heart": "Cuore",
        "ghost": "Fantasma"
      }
    },
    "viewProfileOf": "Vedi il profilo di {{username}}",
    "report": {
      "trigger": "Segnala {{username}}",
      "title": "Segnala {{username}}",
      "intro": "Raccontaci cos'è che non va in questo profilo. Un moderatore lo esaminerà.",
      "reasonLabel": "Motivo",
      "reasons": {
        "offensive_username": "Nome utente offensivo",
        "offensive_avatar": "Immagine del profilo offensiva",
        "harassment": "Molestie o minacce",
        "spam": "Spam o pubblicità",
        "other": "Altro"
      },
      "noteLabel": "Dettagli (facoltativo)",
      "notePlaceholder": "Qualcosa che ci aiuti a capire",
      "privacyHint": "La segnalazione viene conservata per {{days}} giorni per la moderazione. Il profilo è pubblico: non ne salviamo nessuna copia.",
      "submit": "Invia segnalazione",
      "sending": "Invio...",
      "done": "Segnalazione inviata. Grazie.",
      "errors": {
        "duplicate": "Hai già segnalato questo giocatore. Un moderatore ci sta guardando.",
        "notFound": "Questo giocatore non è più disponibile.",
        "self": "Non puoi segnalare te stesso.",
        "registeredOnly": "Serve un account registrato per segnalare da qui.",
        "rateLimited": "Troppe segnalazioni. Riprova più tardi.",
        "generic": "Non è stato possibile inviare la segnalazione. Riprova."
      }
    }
  },
  "gamesHistory": {
    "title": "Storico Partite",
    "gamesPlayed": "{{count}} partite giocate",
    "noGames": "Nessuna partita ancora. Gioca online per vederle qui!",
    "signInToView": "Accedi per vedere il tuo storico partite.",
    "loadingGames": "Caricamento partite...",
    "loadingGame": "Caricamento partita...",
    "failedToLoad": "Caricamento partite fallito",
    "moves": "{{count}} mosse"
  },
  "replay": {
    "backToGames": "Torna alle Partite",
    "loadFailed": "Non siamo riusciti ad aprire questa partita. Riprova.",
    "result": {
      "whiteWins": "Il bianco vince",
      "blackWins": "Il nero vince",
      "draw": "Patta"
    },
    "controls": {
      "goToStart": "Vai all'inizio",
      "previousMove": "Mossa precedente",
      "nextMove": "Mossa successiva",
      "goToEnd": "Vai alla fine",
      "play": "Riproduci",
      "pause": "Pausa",
      "showMoves": "Mostra le mosse",
      "hideMoves": "Nascondi le mosse",
      "position": "Posizione nella partita"
    },
    "downloadPdn": "Scarica PDN",
    "analyzeGame": "Analizza partita",
    "share": "Condividi",
    "shareCopied": "Link copiato!",
    "shareTitle": "Partita di dama",
    "shareText": "Guarda questa partita di dama",
    "shareSheet": {
      "pdnTitle": "Scarica PDN",
      "withNotes": "Con le mie note ({{count}})",
      "withoutNotes": "Senza note",
      "pdnIntro": "Le note diventano commenti dentro il file PDN."
    }
  },
  "review": {
    "save": {
      "save": "Salva partita",
      "saved": "Salvata",
      "title": "Salva la partita",
      "intro": "Scegli una cartella per ritrovare questa partita.",
      "confirm": "Salva",
      "remove": "Rimuovi dai salvati",
      "error": "Non è stato possibile salvare la partita"
    },
    "folders": {
      "unsorted": "Senza cartella",
      "newLabel": "Nuova cartella",
      "newPlaceholder": "Nome della cartella",
      "create": "Crea",
      "duplicate": "Esiste già una cartella con questo nome",
      "rename": "Rinomina",
      "renameFolder": "Rinomina «{{name}}»",
      "renameLabel": "Nuovo nome della cartella",
      "renameError": "Non è stato possibile rinominare la cartella",
      "delete": "Elimina",
      "deleteFolder": "Elimina «{{name}}»",
      "deleteConfirm": "Eliminare?",
      "deleteHint": "Le partite non vengono eliminate: tornano in «Senza cartella».",
      "deleteError": "Non è stato possibile eliminare la cartella",
      "filterLabel": "Cartella",
      "savedOnly": "Solo salvate",
      "gameCount_one": "{{count}} partita",
      "gameCount_other": "{{count}} partite"
    },
    "notes": {
      "add": "Aggiungi nota",
      "atStart": "Nota sulla posizione iniziale",
      "atMove": "Nota alla mossa {{ply}}",
      "placeholder": "Scrivi una nota su questa posizione…",
      "save": "Salva nota",
      "delete": "Elimina nota",
      "jumpTo": "Vai alla nota alla mossa {{ply}}",
      "error": "Non è stato possibile salvare la nota",
      "hasNote": "Questa posizione ha una nota"
    }
  },
  "leaderboard": {
    "title": "Classifica",
    "subtitle": "Top 100 Giocatori",
    "loading": "Caricamento classifica...",
    "empty": "Nessun giocatore con partite completate.",
    "allTime": "Rating",
    "mostGames": "Più attivi",
    "bullet": "Bullet",
    "blitz": "Blitz",
    "rapid": "Rapid",
    "classical": "Classical",
    "columns": {
      "rank": "#",
      "player": "Giocatore",
      "rating": "Rating",
      "class": "Classe",
      "games": "Partite",
      "days": "Giorni",
      "record": "Record"
    },
    "period": {
      "label": "Giorni",
      "days": "{{days}} giorni",
      "all": "Sempre"
    },
    "emptyPeriod": "Nessuna partita in questa variante negli ultimi {{days}} giorni.",
    "emptyStreak": "Nessuno ha una streak attiva in questo momento.",
    "classes": {
      "novice": "Principiante",
      "intermediate": "Intermedio",
      "advanced": "Avanzato",
      "expert": "Esperto",
      "master": "Maestro",
      "grandmaster": "Gran Maestro",
      "legend": "Leggenda"
    }
  },
  "tournament": {
    "title": "Tornei",
    "subtitle": "Metti alla prova le tue abilità nei tornei",
    "list": {
      "heroTitle": "I tornei",
      "arenasLink": "Vedi tutte le arene",
      "archive_one": "L'ultimo torneo concluso.",
      "archive_other": "Gli ultimi {{count}} tornei conclusi."
    },
    "createTournament": "Crea un torneo",
    "formats": {
      "arena": "Arena",
      "italoSwiss": "Girone-Svizzero (secondo gli iscritti)",
      "swiss": "Sistema svizzero",
      "roundRobin": "Girone all'italiana (Round Robin)",
      "arenaShort": "Arena",
      "italoSwissShort": "Girone-Svizzero",
      "swissShort": "Svizzero",
      "roundRobinShort": "Girone"
    },
    "filters": {
      "all": "Tutti",
      "live": "In Corso",
      "upcoming": "Prossimi",
      "variant": "Variante",
      "status": "Stato",
      "international": "Internazionale",
      "italian": "Italiana",
      "english": "Inglese",
      "brazilian": "Brasiliana",
      "comingSoon": "Prossimamente",
      "owner": "Tornei",
      "mine": "I miei"
    },
    "sections": {
      "live": "In Corso",
      "upcoming": "Prossimi",
      "finished": "Terminati"
    },
    "status": {
      "live": "LIVE",
      "upcoming": "PROSSIMO",
      "finished": "TERMINATO",
      "scheduled": "PROGRAMMATO",
      "cancelled": "ANNULLATO"
    },
    "card": {
      "rated": "Valutato",
      "registered": "Iscritto",
      "gamesPlayed_one": "{{count}} partita giocata",
      "gamesPlayed_other": "{{count}} partite giocate",
      "players_one": "{{count}} giocatore",
      "players_other": "{{count}} giocatori",
      "starts": "Inizia {{time}}",
      "startsAt": "Inizia alle {{time}}",
      "startsAtTomorrow": "Inizia domani alle {{time}}",
      "startsAtDate": "Inizia il {{date}} alle {{time}}",
      "startsInCountdown": "Inizia tra {{time}}",
      "startingNow": "Inizia ora!",
      "privateHint": "Torneo privato: serve un invito o la password",
      "publicHint": "Torneo pubblico: aperto a tutti",
      "private": "Privato",
      "seats": "Posti",
      "yourPlace": "tu {{rank}}º",
      "gettoneAlle": "Inizia alle",
      "gettoneDomani": "Domani alle",
      "gettoneData": "{{date}} alle",
      "gettoneTra": "Inizia tra",
      "gettoneMin": "min"
    },
    "empty": {
      "live": "Nessun torneo in corso al momento.",
      "upcoming": "Nessun torneo programmato.",
      "all": "Nessun torneo disponibile.",
      "mine": "Non hai tornei. Creane uno, oppure entra con un invito.",
      "finished": "Nessun torneo concluso.",
      "goLive": "Guarda quelli in corso",
      "goUpcoming": "Guarda i prossimi",
      "goFinished": "Guarda l'archivio"
    },
    "loading": "Caricamento tornei...",
    "notFound": "Torneo non trovato",
    "detail": {
      "timeControl": "Controllo Tempo",
      "duration": "Durata",
      "players": "Giocatori",
      "games": "Partite",
      "startsIn": "Inizia {{time}}",
      "joinTournament": "Partecipa al Torneo",
      "register": "Iscriviti",
      "unregister": "Annulla iscrizione",
      "leaveTournament": "Abbandona Torneo",
      "yourStats": "Le Tue Statistiche",
      "points": "Punti",
      "rank": "Posizione",
      "askPassword": "Password del torneo",
      "share": "Condividi l'invito",
      "shareStandings": "Condividi la classifica",
      "shareCopied": "Link copiato",
      "cancelTournament": "Annulla torneo",
      "cancelConfirm": "Il torneo sparisce e gli iscritti vengono avvisati. Non si torna indietro.",
      "cancelYes": "Sì, annulla",
      "cancelNo": "No, lascialo",
      "createdBy": "Creato da {{username}}",
      "regenerate": "Rifai le chiavi",
      "regenerateHint": "Il link di prima smette di funzionare. Scegli la nuova password e rimanda l’invito agli iscritti.",
      "regenerateNewPassword": "Nuova password",
      "regenerateConfirm": "Rifai le chiavi",
      "regenerateCancel": "Lascia stare",
      "regenerateDone": "Chiavi rifatte: il vecchio link non vale più",
      "ratingFloor": "Punteggio minimo",
      "aiutoAssenza": "Cosa succede se non gioco?",
      "aiutoApertura": "Perché alcune partite cominciano con mosse già giocate?",
      "formatoTitolo": "Come si decide il formato",
      "formatoOraGirone": "Con gli iscritti di adesso ({{n}}) sarebbe un girone all'italiana.",
      "formatoOraSvizzero": "Con gli iscritti di adesso ({{n}}) sarebbe uno svizzero.",
      "formatoOraPochi": "Per partire servono almeno {{min}} iscritti: adesso sono {{n}}.",
      "formatoPrevisto": "Previsto",
      "seSvizzero": "Se è svizzero",
      "seGirone": "Se è girone",
      "punteggio": "Punteggio"
    },
    "scoring": {
      "title": "Punteggio Arena",
      "win": "Vittoria: +{{points}}",
      "draw": "Patta: +{{points}}"
    },
    "standings": {
      "title": "Classifica",
      "liveStandings": "Classifica Live",
      "empty": "Nessun giocatore ancora. Sii il primo a partecipare!",
      "morePlayers_one": "+ {{count}} altro giocatore",
      "morePlayers_other": "+ {{count}} altri giocatori",
      "columns": {
        "rank": "#",
        "player": "Giocatore",
        "points": "Punti",
        "status": "Stato",
        "winsDrawsLosses": "V/P/S",
        "winsDrawsLossesByes": "V/P/S/R",
        "byes": "Rip"
      },
      "status": {
        "playing": "In gioco",
        "ready": "Pronto",
        "paused": "In pausa",
        "left": "Uscito",
        "offline": "Non in linea",
        "assente": "Assente",
        "haFinito": "In attesa",
        "riposa": "Riposa",
        "disconnesso": "Disconnesso"
      },
      "tied": "Ex aequo",
      "tiebreakHelp": "Come si sciolgono i pari punti?",
      "sdSigla": "SD",
      "sdSpiega": "Precede {{nomi}} negli scontri diretti fra i pari punti",
      "scoreSheet": {
        "label": "Andamento: {{esiti}}",
        "outcome": {
          "win": "vinta",
          "winPlus": "vinta, valsa di più",
          "draw": "patta",
          "loss": "persa",
          "bye": "riposo"
        },
        "clipped": "le più vecchie restano fuori a sinistra",
        "hint": "Tutte le partite, la più recente a destra",
        "hintRiposoSvizzero": "il quadrato è un riposo, e vale come una vittoria",
        "hintRiposoGirone": "il quadrato è un riposo, e non dà punti"
      }
    },
    "lobby": {
      "leaveTournament": "Abbandona Torneo",
      "waitingForOpponent": "In attesa dell'avversario...",
      "pts": "pti",
      "rank": "pos",
      "yourPosition": "La Tua Posizione"
    },
    "timer": {
      "remaining": "Rimasto",
      "finished": "Terminato",
      "started": "Iniziato",
      "daysHours": "{{days}}g {{hours}}h"
    },
    "tabs": {
      "standings": "Classifica",
      "games": "Partite",
      "details": "Dettagli",
      "participants": "Partecipanti",
      "gamesPlaceholder": "Le partite recenti appariranno qui"
    },
    "rules": {
      "title": "Regole Punteggio"
    },
    "create": {
      "title": "Crea un torneo",
      "infoAbout": "Informazioni su {{campo}}",
      "nameLabel": "Nome Torneo *",
      "namePlaceholder": "es. Arena Blitz Domenica",
      "nameRequired": "Il nome del torneo è obbligatorio",
      "aperturaUnicaHint": "Una sola apertura per tutti i turni e tutte le partite del torneo, utile per un torneo a tema su una singola apertura",
      "aperturaUnicaScelta": "n. {{id}}",
      "aperturaUnicaScegli": "Scegli l’apertura",
      "aperturaUnicaMancante": "Scegli un’apertura per continuare",
      "aperturaUnicaAmichevole": "Questa apertura è troppo squilibrata perché una sola partita la compensi: il torneo è amichevole. Con andata e ritorno resta valutato.",
      "nameLength": "Il nome deve essere tra 3 e 100 caratteri",
      "descriptionLabel": "Descrizione (opzionale)",
      "descriptionPlaceholder": "Descrivi il tuo torneo...",
      "timeControlLabel": "Controllo Tempo",
      "durationLabel": "Durata",
      "startsAtLabel": "Orario inizio",
      "startsAtRange": "Da 5 minuti a 14 giorni da adesso.",
      "startsAtInvalid": "Scegli un orario fra 5 minuti e 14 giorni da adesso.",
      "visibilityLabel": "Visibilità",
      "visibilityPublic": "Pubblico",
      "visibilityPrivate": "Privato",
      "passwordLabel": "Password del torneo",
      "passwordHint": "La vedrai anche dopo, per poterla condividere. Non usare la password del tuo account.",
      "passwordRequired": "Un torneo privato ha bisogno di una password",
      "estimate": "{{players}} giocatori, {{rounds}} turni → circa {{duration}}, fine verso le {{end}}",
      "estimateRange": "{{players}} giocatori, da {{roundsMin}} a {{roundsMax}} turni → circa {{duration}}, fine entro le {{end}}",
      "durationOptions": {
        "30min": "30 min",
        "1hour": "1 ora",
        "1.5hours": "1,5 ore",
        "2hours": "2 ore",
        "3hours": "3 ore"
      },
      "minRatingLabel": "Rating Min",
      "maxRatingLabel": "Rating Max",
      "ratedLabel": "Valutato",
      "ratingFloorLabel": "Sbarramento",
      "ratingFloorHint": "Sotto questo punteggio non si entra. Si misura sul punteggio della variante e della cadenza di questo torneo: chi non ha mai giocato quella combinazione conta come esordiente. Vale solo sui tornei valutati.",
      "ratingFloorNone": "Nessuno",
      "variantLabel": "Variante",
      "variantInternational": "Internazionale (10×10)",
      "variantItalian": "Italiana (8×8)",
      "variantEnglish": "Inglese (8×8)",
      "formatLabel": "Formato",
      "maxPlayersLabel": "Max giocatori",
      "thresholdLabel": "Svizzero da",
      "thresholdHint": "Da {{n}} iscritti in su si gioca a sistema svizzero; sotto, girone all'italiana. I turni li fissa l'inizio, contando chi si è presentato. Con tre o quattro iscritti il girone si gioca anche di ritorno: sempre tre turni, ma di due partite ciascuno, perché una partita per avversario sarebbe troppo poco.",
      "extraRoundLabel": "Turni extra (svizzero)",
      "extraRoundHint": "Uno o due turni in più di quelli della tabella, fin dove il campo li regge. Nel girone non cambia nulla: lì tutti incontrano tutti, e un turno in più sarebbe una rivincita per tutti.",
      "extraRoundsNone": "Nessuno",
      "extraRoundsOne": "+1 turno",
      "extraRoundsTwo": "+2 turni",
      "tooLongWarningSeats": "Più di un giorno di gioco: togli qualche posto o accorcia la cadenza.",
      "minPlayersLabel": "Min giocatori",
      "minPlayersHint": "Sotto questo numero il torneo si annulla da solo all'ora d'inizio. Più lo alzi, più è probabile che succeda.",
      "seatsWarning": "Oltre questo numero nessuno potrà più entrare, e non potrai cambiarlo dopo.",
      "submitButton": "Crea Torneo",
      "submitting": "Creazione...",
      "failedToCreate": "Creazione torneo fallita",
      "arenaHint": "In arena non ci sono turni: si viene accoppiati di continuo, finche' il tempo non scade.",
      "arenaDurationHint": "Quanto resta aperta l'arena. Al massimo otto ore.",
      "arenaSummary": "Arena di {{duration}}, fine verso le {{end}}",
      "twoLegLabel": "Andata e ritorno",
      "twoLegHint": "Ogni accoppiamento si gioca due volte di fila, a colori invertiti.",
      "twoLegItaloHint": "Le stesse due persone si incontrano due volte nello stesso turno, a colori invertiti e sulla stessa apertura: il turno dura il doppio, non raddoppia il numero dei turni. Con tre o quattro iscritti il ritorno si gioca sempre, qualunque cosa dica questo interruttore.",
      "boostLabel": "Boost",
      "boostHint": "Chi gioca può scommettere: rinuncia a metà del tempo base e all'incremento, e se vince i punti raddoppiano. Si prende prima della propria prima mossa. Spento, in quest'arena non lo usa nessuno.",
      "roundsHelp": "Quanti turni si giocano?"
    },
    "games": {
      "allGames": "Tutte le partite",
      "myGames": "Le mie partite",
      "noGames": "Nessuna partita giocata",
      "moves": "mosse",
      "analyze": "Analizza",
      "round": "Turno {{n}}"
    },
    "participants": {
      "sortByScore": "Per punteggio",
      "sortByRating": "Per rating",
      "sortByName": "A-Z",
      "status": {
        "playing": "In gioco",
        "online": "Online",
        "offline": "Offline"
      }
    },
    "matchFound": {
      "title": "Avversario trovato!",
      "opponent": "Avversario",
      "playAsWhite": "Giochi con il bianco",
      "playAsBlack": "Giochi con il nero",
      "startingIn": "Inizio tra...",
      "startNow": "Inizia ora"
    },
    "postGame": {
      "currentRank": "Posizione attuale",
      "continue": "Continua"
    },
    "signInToJoin": "Accedi per partecipare ai tornei",
    "roundRobin": {
      "scontroDiretto": "Scontro diretto fra i giocatori a pari punti (in classifica «SD»)",
      "tiebreakerInfo": "Spareggi: vittorie, scontro diretto, Sonneborn-Berger, variazione di rating nel torneo"
    },
    "swiss": {
      "roundOf": "Turno {{current}} di {{total}}",
      "scoringWin": "Vittoria: +{{points}}",
      "scoringDraw": "Patta: +{{points}}",
      "scoringLoss": "Sconfitta: {{points}}",
      "buchholz": "BH",
      "sb": "SB",
      "variazione": "Δ",
      "variazioneTitolo": "Variazione di rating nel torneo",
      "criterioVittorie": "Numero di vittorie",
      "tiebreakersTitle": "Spareggi",
      "buchholzCut1": "Buchholz (Cut 1)",
      "sonnebornBerger": "Sonneborn-Berger (SB)",
      "cannotJoinInProgress": "Questo torneo svizzero è già in corso: non ci si può entrare a torneo iniziato.",
      "returnLegPending": "Il ritorno sta per cominciare: stessi avversari, colori invertiti.",
      "waitingBetweenRounds": "In attesa del prossimo turno...",
      "waitingFinalResults": "In attesa dei risultati finali...",
      "waitingForRoundEnd": "In attesa della fine del turno...",
      "tiebreakerInfo": "Spareggi: Buchholz Cut 1, Sonneborn-Berger, vittorie, variazione di rating nel torneo",
      "byeRoundPunti": "Questo turno riposi: +{{punti}} punti, già in classifica.",
      "byeRoundNessunPunto": "Questo turno riposi: nel girone il riposo non dà punti.",
      "byeProssimoTurno": "Il prossimo turno parte da solo quando finiscono le altre partite.",
      "byeUltimoTurno": "I risultati finali arrivano quando finiscono le altre partite.",
      "returnLegTra": "Il ritorno comincia tra {{secondi}} s: stessi avversari, colori invertiti.",
      "partiteConcluse": "Partite concluse: {{completate}} su {{totali}}",
      "turnoParteDaSolo": "Il prossimo turno parte da solo",
      "nonCiSiRitira": "A torneo iniziato non ci si ritira: chi non gioca resta in gara e perde per tempo le sue partite."
    },
    "errors": {
      "authRequired": "Devi accedere per partecipare a un torneo.",
      "guestNotAllowed": "I tornei sono riservati agli account registrati.",
      "notAllowed": "Operazione non consentita.",
      "notFound": "Questo torneo non esiste più.",
      "userNotFound": "Giocatore non trovato.",
      "invalidInput": "Richiesta non valida.",
      "rateLimited": "Troppe richieste: aspetta un momento.",
      "joinFailed": "Iscrizione non riuscita. Riprova.",
      "arenaPiena": "Quest'arena è al completo: i posti sono esauriti.",
      "arenaChiusa": "Quest'arena non accetta più iscrizioni.",
      "giaIscritto": "Sei già iscritto a quest'arena.",
      "arenaAnnullata": "Quest'arena è stata annullata: all'ora d'inizio non c'erano abbastanza iscritti.",
      "notJoinable": "Le iscrizioni a questo torneo sono chiuse.",
      "roundsStarted": "Il turno è già iniziato.",
      "ratingTooLow": "Il tuo punteggio è sotto il minimo richiesto da questo torneo.",
      "wrongFormat": "Formato di torneo non corrispondente.",
      "privateTournament": "Questo torneo è privato: serve il link o la password.",
      "wrongPassword": "Password sbagliata.",
      "tooManyAttempts": "Troppi tentativi. Riprova fra un quarto d'ora.",
      "tournamentFull": "Il torneo è al completo.",
      "alreadyHasLive": "Hai già 3 gare in corso: potrai aprirne un’altra quando una sarà finita.",
      "nameTaken": "C'è già un torneo con questo nome a quell'ora.",
      "startTooSoon": "Troppo presto: lascia almeno cinque minuti per invitare qualcuno.",
      "startTooFar": "Troppo in là: al massimo due settimane da adesso.",
      "notOrganizer": "Solo chi ha aperto il torneo può farlo.",
      "alreadyStarted": "Il torneo è già partito.",
      "tooLong": "Il torneo durerebbe più di un giorno: togli qualche turno o accorcia la cadenza.",
      "cancelledByOrganizer": "Il torneo è stato annullato da chi l'ha organizzato.",
      "cancelledNoPlayers": "Il torneo è stato annullato: non è arrivato il numero minimo di giocatori.",
      "serverError": "Errore del server. Riprova più tardi.",
      "offline": "Sembri offline: controlla la connessione.",
      "timeout": "Il server non ha risposto. Riprova.",
      "loadFailed": "Non è stato possibile caricare i tornei.",
      "notYourTurn": "Non è il tuo turno.",
      "drawOfferFailed": "Non è stato possibile proporre la patta.",
      "unknown": "Qualcosa è andato storto. Riprova.",
      "moveRejected": "Il server ha rifiutato la tua mossa: la damiera è tornata com’era.",
      "partitaSvanita": "La partita non è più sul server: probabilmente è stato riavviato. Sei tornato alla lobby del torneo.",
      "notInTournament": "Non risulti iscritto a questo torneo.",
      "tournamentFullWayOut": "Guarda gli altri tornei e le arene",
      "notPrivate": "Questo torneo è pubblico: non ha chiavi da rifare",
      "samePassword": "La nuova password è uguale a quella di prima",
      "tournamentCancelled": "Il torneo è stato annullato.",
      "inviteLinkExpired": "Questo link d’invito non vale più: entra con la password."
    },
    "ended": {
      "title": "Torneo terminato",
      "winner": "Vincitore",
      "noWinner": "Nessun vincitore: non è stata giocata nessuna partita.",
      "tiedWith": "Primo a pari merito con {{players}}"
    },
    "share": {
      "title": "Torneo di dama",
      "text": "Ti invito al torneo {{nome}} su draughtsgame.com",
      "standingsTitle": "Classifica finale — {{nome}}"
    }
  },
  "chat": {
    "title": "Chat",
    "openChat": "Apri chat",
    "closeChat": "Chiudi chat",
    "empty": "Nessun messaggio ancora. Saluta!",
    "placeholder": "Scrivi un messaggio...",
    "unavailable": "Chat non disponibile",
    "opponentLeft": "L'avversario ha lasciato la partita.",
    "rateLimited": "Stai scrivendo troppo in fretta: aspetta qualche secondo.",
    "closingIn": "La chat si chiude tra {{seconds}}s",
    "closed": "La chat di questa partita è chiusa.",
    "guestHint": "Gli ospiti possono inviare reazioni rapide. Registrati per la chat completa.",
    "report": {
      "trigger": "Segnala",
      "title": "Segnala {{username}}",
      "intro": "Raccontaci cos'è successo. Un moderatore esaminerà la chat di questa partita.",
      "quoteLabel": "Ultimo messaggio di {{username}}",
      "reasonLabel": "Motivo",
      "reasons": {
        "insult": "Insulti o linguaggio offensivo",
        "harassment": "Molestie o minacce",
        "hate_speech": "Odio o discriminazione",
        "spam": "Spam o pubblicità",
        "other": "Altro"
      },
      "noteLabel": "Dettagli (facoltativo)",
      "notePlaceholder": "Qualcosa che ci aiuti a capire",
      "privacyHint": "La chat di questa partita (fino a 100 messaggi, di entrambi i giocatori) viene salvata per la moderazione e conservata per {{days}} giorni.",
      "submit": "Invia segnalazione",
      "sending": "Invio...",
      "done": "Segnalazione inviata. Grazie.",
      "muted": "Hai segnalato questo giocatore. I suoi messaggi sono nascosti.",
      "errors": {
        "gone": "La partita è finita e la sua chat non è più verificabile. Scrivici dalla pagina Aiuto.",
        "duplicate": "Hai già segnalato questo giocatore per questa partita.",
        "notReportable": "Questo avversario non può essere segnalato.",
        "notInGame": "Non stai giocando questa partita.",
        "rateLimited": "Troppe segnalazioni. Riprova più tardi.",
        "generic": "Non è stato possibile inviare la segnalazione. Riprova."
      }
    },
    "quickPhrases": "Frasi rapide",
    "presets": {
      "hello": "Ciao!",
      "goodLuck": "Buon gioco!",
      "haveFun": "Buon divertimento!",
      "goodGame": "Bella partita!",
      "untilNext": "Alla prossima!",
      "thanks": "Grazie!"
    }
  },
  "landing": {
    "nav": {
      "title": "Dama Online",
      "play": "Gioca",
      "tournaments": "Tornei",
      "learn": "Impara",
      "community": "Community",
      "login": "Accedi"
    },
    "hero": {
      "badge": "L'Esperienza Definitiva della Dama",
      "title": "Diventa un Maestro della Dama",
      "subtitle": "Gioca contro giocatori di tutto il mondo, partecipa ai tornei e migliora le tue abilità con i nostri strumenti di allenamento avanzati.",
      "playFree": "Gioca Ora",
      "watchDemo": "Guarda Demo"
    },
    "stats": {
      "players": "Giocatori Attivi",
      "games": "Partite Giocate",
      "variants": "Varianti di Gioco",
      "tournaments": "Tornei Giornalieri"
    },
    "features": {
      "title": "Perché Scegliere Dama Online?",
      "subtitle": "Tutto ciò di cui hai bisogno per diventare un maestro della dama",
      "variants": {
        "title": "Varianti Multiple",
        "description": "Gioca a dama Italiana, Internazionale, Inglese e Brasiliana - tutto in un'unica piattaforma."
      },
      "matchmaking": {
        "title": "Matchmaking Intelligente",
        "description": "Il nostro sistema di rating Glicko-2 garantisce partite equilibrate e competitive ogni volta."
      },
      "tournaments": {
        "title": "Tornei Arena",
        "description": "Competi in tornei giornalieri con giocatori da tutto il mondo."
      },
      "ai": {
        "title": "Allenamento con IA",
        "description": "Allenati contro la nostra IA avanzata con più livelli di difficoltà."
      },
      "analysis": {
        "title": "Analisi Partite",
        "description": "Rivedi le tue partite e impara dai tuoi errori con analisi dettagliate."
      },
      "community": {
        "title": "Community Attiva",
        "description": "Unisciti ai club, chatta con altri giocatori e fai amicizia con chi condivide la tua passione."
      }
    },
    "variants": {
      "title": "Gioca la Tua Variante Preferita",
      "subtitle": "Supportiamo le varianti di dama più popolari da tutto il mondo",
      "pieces": "pedine",
      "italian": "Dama Italiana",
      "international": "Dama Internazionale",
      "english": "Dama Inglese",
      "brazilian": "Dama Brasiliana"
    },
    "testimonials": {
      "1": {
        "name": "Marco B.",
        "role": "Giocatore di Tornei",
        "text": "La migliore piattaforma di dama che abbia mai usato. Il matchmaking è equilibrato e i tornei sono emozionanti!"
      },
      "2": {
        "name": "Elena V.",
        "role": "Giocatrice Casual",
        "text": "Adoro quanto sia facile trovare una partita. L'interfaccia è bella e intuitiva."
      },
      "3": {
        "name": "Hans K.",
        "role": "Campione di Club",
        "text": "Finalmente una piattaforma che prende sul serio la dama internazionale. Altamente consigliata!"
      },
      "title": "Cosa Dicono i Giocatori"
    },
    "cta": {
      "title": "Pronto a Giocare?",
      "subtitle": "Unisciti a migliaia di giocatori e inizia il tuo viaggio nella dama oggi.",
      "button": "Inizia a Giocare Ora"
    },
    "footer": {
      "tagline": "La piattaforma di dama online per eccellenza",
      "game": "Gioco",
      "playNow": "Gioca Ora",
      "tournaments": "Tornei",
      "leaderboard": "Classifica",
      "puzzles": "Puzzle",
      "learn": "Impara",
      "tutorial": "Tutorial",
      "strategies": "Strategie",
      "rules": "Regole",
      "videos": "Video",
      "community": "Community",
      "forum": "Forum",
      "clubs": "Club",
      "blog": "Blog",
      "discord": "Discord",
      "rights": "Tutti i diritti riservati."
    }
  },
  "arena": {
    "title": "Arena",
    "subtitle": "Gioco continuo a ritmo serrato",
    "ending": "In chiusura...",
    "status": {
      "live": "LIVE",
      "upcoming": "PROSSIMA",
      "finished": "TERMINATA"
    },
    "card": {
      "yourPlace": "tu {{rank}}º"
    },
    "actions": {
      "join": "Partecipa",
      "leave": "Esci",
      "play": "Gioca",
      "pause": "Pausa",
      "resume": "Riprendi",
      "boost": "Boost",
      "backToGame": "Torna alla partita",
      "retry": "Riprova"
    },
    "errors": {
      "authRequired": "Devi accedere per partecipare all'arena.",
      "guestNotAllowed": "Gli ospiti non possono iscriversi a un'arena. Crea un account per tenere le tue partite.",
      "notAllowed": "Questo account non può iscriversi a un'arena.",
      "arenaNotFound": "Quest'arena non esiste più.",
      "userNotFound": "Non troviamo il tuo account. Accedi di nuovo.",
      "invalidInput": "La richiesta non era valida. Ricarica la pagina e riprova.",
      "rateLimited": "Troppi tentativi. Aspetta qualche secondo e riprova.",
      "ratingTooLow": "Il tuo punteggio è sotto il minimo richiesto da questa arena.",
      "joinFailed": "Non siamo riusciti a iscriverti all'arena. Riprova.",
      "arenaPiena": "Quest'arena è al completo: i posti sono esauriti.",
      "arenaChiusa": "Quest'arena non accetta più iscrizioni.",
      "giaIscritto": "Sei già iscritto a quest'arena.",
      "arenaScaduta": "Il tempo di quest'arena è scaduto: si aspetta solo la fine delle ultime partite.",
      "arenaAnnullata": "Quest'arena è stata annullata.",
      "arenaAnnullataPochiIscritti": "Quest'arena è stata annullata: all'ora d'inizio non c'erano abbastanza iscritti.",
      "arenaAnnullataDaOrganizzatore": "Chi ha aperto quest'arena l'ha annullata.",
      "notOrganizer": "Solo chi ha aperto l'arena può farlo.",
      "alreadyStarted": "L'arena è già partita.",
      "giaInUnArena": "Sei già in un’arena in corso: esci da quella per giocare in questa",
      "leaveFailed": "Non siamo riusciti a farti uscire dall'arena. Riprova.",
      "notInArena": "Non sei iscritto a quest'arena.",
      "notInGame": "Non stai giocando questa partita.",
      "gameNotFound": "Questa partita non esiste più.",
      "tooLate": "Troppo tardi: il boost si cambia solo prima della tua prima mossa.",
      "boostDisabled": "In quest'arena il boost è spento.",
      "alreadyBoosted": "Il boost è già attivo in questa partita.",
      "notBoosted": "Il boost non è attivo in questa partita.",
      "boostFailed": "Non siamo riusciti ad attivare il boost. Riprova.",
      "unboostFailed": "Non siamo riusciti a disattivare il boost. Riprova.",
      "serverError": "Qualcosa è andato storto da parte nostra. Riprova.",
      "offline": "Nessuna connessione al server.",
      "timeout": "Il server non ha risposto. Riprova.",
      "unknown": "Qualcosa è andato storto. Riprova.",
      "notYourTurn": "Non è il tuo turno.",
      "drawOfferFailed": "Non siamo riusciti a proporre la patta. Riprova.",
      "moveRejected": "Il server ha rifiutato la tua mossa: la damiera è tornata com’era."
    },
    "standings": {
      "search": "Cerca un giocatore",
      "searchEmpty": "Nessun giocatore con questo nome.",
      "sheetHint": "Tutte le partite, la più recente a destra · oro = bonus",
      "loadMore": "Mostra altri",
      "sheet": "Partite",
      "toClimb_one": "{{count}} punto per salire",
      "toClimb_other": "{{count}} punti per salire",
      "lead_one": "{{count}} punto di vantaggio",
      "lead_other": "{{count}} punti di vantaggio",
      "boostOn": "boost attivato",
      "searchScope": "La ricerca guarda solo le righe già caricate: carica le altre per cercare fra tutti.",
      "justPlayedHint": "Il segno ↺: ci hai appena giocato — accanto c'è quanto manca prima che ti venga riproposto.",
      "justPlayedIn": "Già affrontato: torna disponibile fra {{time}}",
      "tiebreakOpp": "Avversari",
      "tiebreakOppTitle": "Media dei punti degli avversari affrontati",
      "tiebreakH2hTitle": "Scontro diretto fra i giocatori a pari punti: vittorie meno sconfitte",
      "tiebreakHint": "A pari punti: più vittorie, poi lo scontro diretto, poi avversari più forti, poi meno partite giocate."
    },
    "info": {
      "details": "Dettagli",
      "scoring": "Sistema Punteggio",
      "loss": "Sconfitta: {{points}}",
      "boostTitle": "Boost ⚡",
      "boostTimeCost": "Ti toglie l'incremento e dimezza il tempo base",
      "boostExtraPoint": "Raddoppia i punti vittoria se vinci",
      "boostBeforeFirst": "Si può accendere e spegnere fino alla tua prima mossa"
    },
    "matchFound": {
      "title": "Avversario Trovato",
      "opponent": "Avversario",
      "playAsWhite": "Giochi con il Bianco",
      "playAsBlack": "Giochi con il Nero",
      "startingIn": "Inizia tra",
      "startNow": "Inizia Ora"
    },
    "gameEnd": {
      "win": "Vittoria",
      "loss": "Sconfitta",
      "draw": "Patta",
      "pointsEarned": "Punti guadagnati",
      "basePoints": "Punti base",
      "boostBonus": "Bonus boost",
      "total": "Totale",
      "pointsVoided": "Partita non conteggiata: nessun punto assegnato a nessuno dei due",
      "rank": "Posizione",
      "totalPoints": "Punti",
      "paused": "Sei in pausa: riprendi quando vuoi.",
      "arenaFinished": "Arena terminata",
      "arenaDraining": "Tempo scaduto: l'arena chiude appena finiscono le ultime partite.",
      "analyze": "Analizza",
      "pause": "In pausa",
      "playNext": "Continua",
      "backToArena": "Torna all’arena",
      "resumeFailed": "Non siamo riusciti a rimetterti in coda: controlla la connessione e riprova.",
      "returnLegIn_one": "Ritorno fra {{count}} secondo…",
      "returnLegIn_other": "Ritorno fra {{count}} secondi…"
    },
    "game": {
      "boost": "Boost",
      "boostRemove": "Rimuovi",
      "boostRetry": "Riprova"
    },
    "confirmBoost": {
      "title": "Attivare il boost?",
      "halve": "Il tempo base passa da {{prima}} a {{dopo}} e perdi l’incremento di {{incremento}}s.",
      "halveOnly": "Il tempo base passa da {{prima}} a {{dopo}}.",
      "reward": "Se vinci, i punti valgono il doppio. Puoi rimuoverlo fino alla tua prima mossa.",
      "confirm": "Attiva"
    },
    "results": {
      "arenaFinished": "Arena Conclusa",
      "yourPosition": "La tua posizione",
      "outOf_one": "su {{count}} giocatore",
      "outOf_other": "su {{count}} giocatori",
      "totalPoints": "Punti totali",
      "games": "partite",
      "winRate": "Win rate",
      "share": "Condividi",
      "nextArena": "Prossima Arena",
      "unavailable": "Non abbiamo i risultati di quest’arena.",
      "unavailableSub": "Torna all’elenco e riaprila dalla scheda «Terminate»."
    },
    "tabs": {
      "rules": "Regole"
    },
    "signInToJoin": "Accedi per partecipare alle arene",
    "positionCta": "Unisciti e competi per scalare la classifica!",
    "band": {
      "searchingTitle": "Cerco un avversario",
      "searchingSub": "Ti porto io in partita appena trovo l’abbinamento.",
      "drainingTitle": "Il tempo è scaduto",
      "drainingSub": "Non accoppio più nessuno: appena finiscono le ultime partite esce la classifica finale.",
      "pausedTitle": "Sei in pausa",
      "pausedSub": "Non ti accoppio con nessuno finché non riprendi.",
      "pausedAwaySub": "Ti ho messo in pausa perché l'app era in secondo piano. Riprendi quando vuoi.",
      "pausedOfflineSub": "Ti ho messo in pausa perché non eri collegato quando l'arena è partita.",
      "pausedOtherArenaSub": "Sei in gara nell’altra arena. Quando hai finito lì, premi Riprendi per tornare in coda qui.",
      "playingTitle": "Sei in partita",
      "playingSub": "La partita è ancora aperta: torna a giocarla.",
      "playingSubVs": "Contro {{opponent}} · col {{color}}.",
      "waitingTitle": "Sei iscritto",
      "waitingSub": "L’arena non è ancora cominciata.",
      "joinTitle": "Non sei iscritto",
      "joinSub": "Entra e ti accoppio con chi è in coda."
    },
    "timebar": {
      "endsIn": "Finisce fra"
    },
    "games": {
      "deletedPlayer": "Giocatore cancellato",
      "loadFailed": "Non siamo riusciti a caricare le partite."
    },
    "a11y": {
      "scoreUpdate": "Ora hai {{points}} punti, posizione {{rank}}"
    },
    "spotlight": {
      "eyebrow": "Arena",
      "daysHours": "{{days}}g {{hours}}h",
      "startsIn": "Inizia fra",
      "yourResult": "Hai chiuso {{rank}}º",
      "review": "Vedi com'è andata"
    },
    "twoLeg": "Andata/ritorno",
    "noBoost": "Senza boost",
    "share": {
      "title": "Arena di dama",
      "text": "Sei invitato all’arena {{nome}} su draughtsgame.com"
    },
    "detail": {
      "askPassword": "Password dell'arena",
      "share": "Condividi invito",
      "shareCopied": "Link copiato",
      "cancelArena": "Annulla arena",
      "cancelConfirm": "L'arena sparisce e gli iscritti vengono avvisati. Non si torna indietro."
    }
  },
  "specialEvent": {
    "eyebrow": "Evento speciale",
    "badge": "Speciale",
    "organizedBy": "Organizzato da Draughts Game"
  },
  "legal": {
    "termsTitle": "Termini",
    "privacyTitle": "Privacy",
    "acceptTerms": "Accetto i <terms>Termini di Servizio</terms> e la <privacy>Privacy Policy</privacy>",
    "acceptTermsOnly": "Accetto i <terms>Termini di Servizio</terms>",
    "acceptPrivacyOnly": "Accetto la <privacy>Privacy Policy</privacy>",
    "ageConfirm": "Confermo di avere almeno 16 anni",
    "acceptRequired": "Devi accettare i Termini di Servizio",
    "acceptTermsRequired": "Spunta la casella per accettare i Termini di Servizio",
    "acceptPrivacyRequired": "Spunta la casella per accettare la Privacy Policy",
    "ageRequired": "Spunta la casella per confermare l'età",
    "lastUpdated": "Ultimo aggiornamento",
    "subtitle": "I tuoi diritti e i nostri impegni",
    "missingConsents_one": "Manca ancora {{count}} conferma qui sopra",
    "missingConsents_other": "Mancano ancora {{count}} conferme qui sopra"
  },
  "cookies": {
    "message": "Usiamo cookie essenziali per far funzionare il sito. Se accetti, usiamo anche strumenti di misura — Umami, per sapere come viene usato il sito, e Sentry, per accorgerci degli errori. Puoi rifiutare: il sito funziona lo stesso.",
    "acceptAll": "Accetta tutti",
    "rejectAnalytics": "Solo essenziali"
  },
  "puzzle": {
    "toPlayAndWin": "muove e vince",
    "black": "Nero",
    "white": "Bianco",
    "dashboard": "Dashboard",
    "hint": "Indizio",
    "hintTip": "Un indizio costa solo il rating: il problema diventa non valido per il rating, quindi non guadagni né perdi punti. Conta comunque come risolto e mantiene lo Streak.",
    "solution": "Soluzione",
    "solutionTip": "Rivelare la soluzione conta come tentativo fallito: perdi punti rating, ma la giornata conta comunque per lo Streak.",
    "continueVsAI": "Continua a giocare con AI",
    "playAgain": "Rigioca",
    "back": "Indietro",
    "forward": "Avanti",
    "puzzleRating": "Rating problema",
    "ratingChange": "Rating",
    "newRating": "ora",
    "yourRating": "Il tuo rating",
    "solutionMoves": "Soluzione",
    "moves": "mosse",
    "motifs": "Temi",
    "motifsRevealed": "svelati",
    "motifsHidden": "svelati dopo la soluzione",
    "result": {
      "solvedEyebrow": "Risolto",
      "failedEyebrow": "Soluzione",
      "nice": "Bella",
      "solving": "soluzione.",
      "theLine": "Ecco la",
      "line": "linea."
    },
    "title": "Problemi",
    "loading": "Caricamento problema...",
    "yourTurn": "Trova la mossa migliore!",
    "correct": "Corretto!",
    "incorrect": "Sbagliato",
    "solved": "Problema risolto!",
    "failed": "Problema fallito",
    "giveUp": "Arrendi",
    "nextPuzzle": "Prossimo problema",
    "backToHome": "Torna alla home",
    "rating": "Rating",
    "daily": "Problema del giorno",
    "solve": "Risolvi",
    "demo": {
      "badge": "Puzzle di prova",
      "solvedTitle": "Bravo, risolto!",
      "trainTitle": "Vuoi allenarti ogni giorno?",
      "registerPitch": "Registrati gratis: ogni giorno un problema nuovo, diverso per ogni variante.",
      "registerCta": "Crea un account gratis"
    },
    "practice": "Allenamento",
    "retry": "Riprova",
    "share": "Condividi",
    "shareTitle": "Problema del giorno",
    "shareText": "Ho risolto il problema di oggi — ci riesci anche tu?",
    "shareCopied": "Link copiato!",
    "unavailable": {
      "title": "Questo problema non è disponibile",
      "link": "Non siamo riusciti ad aprire il problema di oggi. Forse per questa variante non ce n’è uno, oppure è caduta la connessione.",
      "session": "Non siamo riusciti ad avviare il problema. Controlla la connessione e riprova.",
      "home": "Vai alla home"
    },
    "invite": {
      "title": "Il puzzle del giorno ti aspetta",
      "body": "Un amico ti ha condiviso il puzzle del giorno. I puzzle del giorno sono riservati ai giocatori registrati: crea un account gratis, oppure accedi, per sbloccare la damiera.",
      "locked": "Anteprima bloccata",
      "tryDemo": "Intanto prova il puzzle demo",
      "moves_one": "{{count}} mossa",
      "moves_other": "{{count}} mosse"
    },
    "guest": {
      "locked": "I problemi del giorno sono riservati agli utenti registrati. Accedi o registrati gratuitamente per giocarli."
    },
    "networkError": "Problema di rete: la mossa non è stata registrata. Riprova."
  },
  "dashboard": {
    "hero": {
      "welcome": "Bentornato",
      "settings": "Impostazioni",
      "ctaPlayNow": "Gioca subito",
      "ctaVsComputer": "Sfida AI",
      "moreVariants": "Altre varianti ({{count}})",
      "logoutConfirmTitle": "Vuoi uscire?",
      "logoutConfirmBody": "Uscirai dal tuo account su questo dispositivo.",
      "ctaDailyPuzzle": "Problemi del giorno",
      "themeDark": "Passa al tema scuro",
      "themeLight": "Passa al tema chiaro",
      "doNotDisturbOn": "Non disturbare",
      "doNotDisturbOff": "Torna disponibile",
      "doNotDisturbBadge": "Occupato",
      "doNotDisturbTurnOff": "Disattiva",
      "ratingDeltaUp": "Su di {{points}} punti negli ultimi 7 giorni",
      "ratingDeltaDown": "Giù di {{points}} punti negli ultimi 7 giorni"
    },
    "notif": {
      "challengedYou": "<b>{{name}}</b> ({{rating}}) ti ha sfidato a <b>{{timeControl}}</b> · {{variant}}",
      "challengedYouNoRating": "<b>{{name}}</b> ti ha sfidato a <b>{{timeControl}}</b> · {{variant}}",
      "accept": "Accetta",
      "decline": "Rifiuta"
    },
    "streak": {
      "daysInRow_one": "{{count}} giorno di fila",
      "daysInRow_other": "{{count}} giorni di fila",
      "unitLabel_one": "giorno di fila",
      "unitLabel_other": "giorni di fila",
      "record": "Record da battere: <b>{{count}} giorni</b>",
      "recordTying": "Record eguagliato: <b>{{count}} giorni</b>",
      "empty": "Inizia oggi",
      "solvePuzzle": "Risolvi un problema",
      "doneToday": "Fatto per oggi 🔥",
      "keepHint": "Gioca o risolvi un problema per non perdere lo streak.",
      "last7DaysLabel": "Attività degli ultimi 7 giorni",
      "festa": {
        "subtitle": "Torna domani per allungarlo"
      }
    },
    "dailyGoal": {
      "title": "Obiettivo giornaliero",
      "label": "Partite",
      "remaining_one": "<b>Una in più</b> per completare l'obiettivo",
      "remaining_other": "<b>{{count}} in più</b> per completare l'obiettivo",
      "done": "Obiettivo raggiunto",
      "targetLabel": "Partite al giorno",
      "editGoal": "Modifica obiettivo",
      "festa": {
        "subtitle": "Obiettivo di oggi completato"
      }
    },
    "festa": {
      "dismiss": "Tocca per chiudere"
    },
    "activity": {
      "title": "Attività",
      "last3Months": "Ultimi 3 mesi",
      "centerGames": "partite",
      "statsGames_one": "{{count}} partita",
      "statsGames_other": "{{count}} partite",
      "statsActiveDays_one": "{{count}} giorno attivo",
      "statsActiveDays_other": "{{count}} giorni attivi",
      "statsPerDay": "{{value}} partite/giorno",
      "empty": "Le tue partite appariranno qui",
      "statsTotalTime": "{{value}} totali",
      "tooltipToday": "Oggi",
      "tooltipYesterday": "Ieri",
      "legendBucket0": "0",
      "legendBucket1": "1-2",
      "legendBucket2": "3-5",
      "legendBucket3": "6-9",
      "legendBucket4": "10+",
      "duration": {
        "zero": "0 min",
        "minutes_one": "{{count}} min",
        "minutes_other": "{{count}} min",
        "hours_one": "{{count}}h",
        "hours_other": "{{count}}h",
        "hoursMinutes": "{{hours}}h {{minutes}}m"
      },
      "dayMon": "Lun",
      "dayThu": "Gio",
      "daySat": "Sab",
      "dayTue": "Mar",
      "dayWed": "Mer",
      "dayFri": "Ven",
      "daySun": "Dom"
    },
    "recentGames": {
      "title": "Partite recenti",
      "viewAll": "Vedi tutte nel profilo →",
      "replay": "Riguarda",
      "empty": "Ancora nessuna partita"
    },
    "upcomingTournaments": {
      "title": "Tornei attivi",
      "viewAll": "Vedi tutti →",
      "viewAllAria": "Vedi tutti i tornei",
      "empty": "Nessun torneo in programma"
    },
    "liveEvent": {
      "emptyTitle": "Tornei e Arene",
      "empty": "Nessun evento live al momento",
      "nextAt": "Il prossimo Daily inizia alle {{time}}",
      "minutesLeft_one": "Termina tra {{count}} minuto",
      "minutesLeft_other": "Termina tra {{count}} minuti",
      "participants_one": "{{count}} giocatore",
      "participants_other": "{{count}} giocatori"
    },
    "puzzle": {
      "titleWhiteToMove": "Bianco muove\ne vince",
      "titleBlackToMove": "Nero muove\ne vince",
      "meta": "Trova la sequenza migliore",
      "cta": "Risolvi →",
      "viewAll": "Tutti →",
      "tag": {
        "tactic": "Tattica"
      },
      "solvedNext": "Risolto ✓ · Torna domani per il prossimo",
      "tryInternational": "Prova un puzzle International →",
      "overlayTitle": "Problemi del giorno"
    },
    "avvisoDati": {
      "offline": "Sembri senza rete: i tuoi dati non si sono caricati.",
      "server": "Non ho potuto caricare i tuoi dati.",
      "inCorso": "Riprovo…",
      "ricarica": "Ricarica"
    },
    "installCard": {
      "eyebrow": "App",
      "title": "Installa Draughts Game",
      "benefit": "Aggiungila alla schermata Home: si apre a schermo intero, parte più in fretta e la ritrovi accanto alle altre app.",
      "howTo": "Come si fa?",
      "choose": "Scegli il tuo dispositivo:",
      "os": {
        "android": "Android",
        "ios": "iPhone o iPad",
        "desktop": "Computer"
      }
    }
  },
  "pwa": {
    "openInAppText": "Sei nel browser interno di WhatsApp. Apri il link fuori da qui per usare l'app per intero.",
    "openInAppCta": "Apri nell'app",
    "openInBrowserText": "Sei nel browser interno di WhatsApp. Apri il link in Safari per usare l'app per intero.",
    "iosHint": "Tocca ••• in basso a destra, poi «Apri in Safari».",
    "installText": "Installa Draughts Game per giocare dalla schermata Home.",
    "installCta": "Installa l'app",
    "copyLink": "Copia link",
    "linkCopied": "Link copiato!",
    "dismiss": "Chiudi"
  },
  "seo": {
    "breadcrumbHome": "Home",
    "landing": {
      "title": "Draughts Game — gioca a dama online gratis",
      "description": "Gioca a dama online gratis: dama italiana, internazionale, turca, frisone e altre 20 varianti. Multigiocatore in tempo reale, partite valutate, tornei, avversari IA e un problema al giorno."
    },
    "faq": {
      "title": "Domande frequenti — giocare a dama online",
      "description": "Risposte su account, punteggio, tornei, installazione dell’app e partite di dama online, più un canale diretto per segnalazioni e proposte."
    },
    "terms": {
      "title": "Termini di Servizio — Draughts Game",
      "description": "Le condizioni che regolano l’uso di Draughts Game: account, lealtà di gioco, punteggio, contenuti e le regole che entrambe le parti accettano."
    },
    "privacy": {
      "title": "Informativa sulla privacy — Draughts Game",
      "description": "Quali dati raccoglie Draughts Game, perché, per quanto tempo li conserva e quali diritti hai su di essi secondo il GDPR."
    }
  }
}
